import React from 'react';
import {
  Grid, List, ListItem, ListItemIcon, ListItemText, Button,
  Typography, Paper, Table, TableHead, TableRow, TableCell, Link,
  TableBody, TableContainer, Card, TextField , Box, Dialog, Tooltip,Modal, Divider,FormControl, InputBase, IconButton,Switch,Select,MenuItem, CircularProgress, Collapse
} from '@material-ui/core';

import Avatar from '@material-ui/core/Avatar';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import {
  History, Home, Group, ViewModule, Apps, LocalOfferOutlined, AccountCircle, Edit as EditIcon, ImageOutlined,
} from '@material-ui/icons';
import AddIcon from "@material-ui/icons/Add";
import {ReactComponent as Clock} from '../../../element/Icons/clock.svg'
import {ReactComponent as Hat} from '../../../element/Icons/hat.svg'
import {ReactComponent as Roof} from '../../../element/Icons/roof.svg'
import {ReactComponent as Stack} from '../../../element/Icons/stack.svg'
import {ReactComponent as WavingDuo} from '../../../element/Icons/waving.svg'

import waving from '../../../element/2024aug/waving_hand.png'
import hat from '../../../element/2024aug/tall_hat.png'
import input_bp from '../../../element/2024aug/input_box_plump.png'
import termsIcon from '../../../element/2026/terms.png'

import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import InviteTeamMembers from './inviteMember';
import GameTopPanel from './gameTopPanel';
import FooterPanel from './gameFooterPanel.tsx';
import { styles } from './assets/frontPageUI';
import config from '../../../config/backend';

import {HOME_PAGE_JAMBUILDER_QUERY, HOME_PAGE_GAME_QUERY, GET_USER_ACTIVITY, GET_JAMS_TEMPLATES,GET_JAMBUILDER, GET_JAMBUILDER_BY_ID, GET_GAME_BY_ID, USER_ACCESS_QUERY, GET_TEAM_MANY, DASHBOARD_QUERY, GET_USER_BY_EMAIL, GET_USER_BY_EMAIL_SINGLE, JAMBUILDER_PERSONAL_PAGE, JAMBUILDER_COMMUNITY_PAGE, JAMBUILDER_FEATURED_COMMUNITY_PAGE, GAME_PERSONAL_PAGE, DASHBOARD_TEAMS_QUERY, JAMBUILDER_BY_CREATORS, GET_USER_PROFILE} from '../../../api/graphql'
import {CREATE_GAME, CREATE_JAMBUILDER, USER_UPDATE_ACTIVITY,GAME_GD_UPDATE_BY_ID, DUPLICATE_GAME, TEAM_ADD_MEMBERS, CREATE_TEAM, TEAM_DELETE_MEMBERS, TEAM_MEMBER_APPROVE, USER_UPDATE_PROFILE, USER_CHANGE_PASSWORD} from '../../../api/graphql-mutation'
import { getUserId, getUsername, getEmail, replaceWhiteSpace, processDeckData} from '../../../utility/function';
import { gd, gd2 } from '../../../utility/temp';
import { can, hintFor, TIER_STEPS, hasCriterion, subtasksFor, targetFor, labelFor } from '../../../utility/permissions';
import { USER_VERIFY_EMAIL, USER_RESEND_VERIFICATION, USER_EVALUATE_TIER, USER_ACCEPT_TERMS } from '../../../api/graphql-mutation';
import PinInput from 'react-pin-input';
import AvatarCropDialog from '../../common/avatarCropDialog';
import UserAvatar from '../../common/userAvatar';
import { avatarUrl } from '../../../utility/avatar';
import EE from '../../../api/eventemitter';
import axios from 'axios'
import gql from 'graphql-tag';

import Landing from './landing';
import { UserAccessContext } from '../../../config/UserAccessProvider';
import { appConfig } from '../../../app/app.config';

class Dashboard extends React.Component {
  // Access the app-wide tier provider so team actions can refresh route-guard capabilities.
  static contextType = UserAccessContext;

  constructor(props) {
    super(props);
    this.state = {
      uid: null,
  selectedMenu: "home",
  showCreateTeam: false,
  selectedTeam: null,
  selectedTeamData: null ,
  teams: [], // store created teams
  // Templates created by each team's members ("Templates by team member"), keyed by team id.
  teamTemplates: {},
  teamTemplatesLoading: false,
  // ...other existing state
  showInvite: false,
  showMember: false,


                  open: false,
            type: '',
            password: '',
            name: '',
            jamBuilder: [],
            deck: '1',
            loaded: true,

            //Activity list
            recentActivity: [],
            recentTemplatesList: [], //recently accessed templates, shown under recent jams
            activityList: [],
            userJams: [],

            //Personal Jambuilders
            jambuilders: [],
            //Public jambuilders
            publicJambuilders: [],

            //Per-tab lazy-load flags: Home loads immediately; each other tab loads only
            //when first opened (see handleMenuClick).
            templatesLoaded: false,   //My Templates + Community first page
            templatesLoading: false,
            teamsLoaded: false,
            teamsLoading: false,

            // Profile tab: loaded user fields + editable drafts. avatarDraft holds a newly
            // uploaded (not-yet-saved) filename; nameDraft holds the edited name.first.
            profileLoaded: false,
            profileLoading: false,
            profileAvatar: null,      // saved avatar filename from the server
            profileName: "",          // saved name.first from the server
            profileEmail: "",
            avatarDraft: null,        // pending uploaded filename before Save Changes
            avatarUploading: false,
            cropImage: null,          // object URL of the picked file while the crop dialog is open
            nameDraft: "",            // pending name.first before Save Changes
            showPasswordForm: false,  // Security starts as just the Reset Password button
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
            passwordMsg: null,        // { type: "error" | "success", text }

            activityLoaded: false,    //recent jams + recent templates (Recent/Joined tabs)
            activityLoading: false,
            hostedLoaded: false,      //hosted games first page
            hostedLoading: false,

            //Server-side pagination cursors: how many rows loaded so far (skip), whether the
            //server has more, and whether a "Load more" fetch is in flight.
            myTemplatesSkip: 0, myTemplatesHasMore: false, myTemplatesLoadingMore: false,
            communitySkip: 0, communityHasMore: false, communityLoadingMore: false,
            hostedSkip: 0, hostedHasMore: false, hostedLoadingMore: false,

            gamejams: [],
            spectateGame: [],
            uid: null,
            guest: false,

            anchorEl: null,
            stickyBits: null,

            //Dialog configs
            dialogOpen: false,
            selectedJB: {
                type: "story",
                jbData: null,
            },
            dialogDeck: null,

            templateDialog: false,

            templateImage: null,

            openPreview: this.props?.location?.state?.openPreview,

            loading: false,

            // Paginated list state
            jamPage: 1,

            loadDone: false,

            // Branch Pop Up
            branchPopUp: false,
            selectedBranch: null,
            branchPop: false,
            branchSuggest: false,

            testLoading: true,

            access: 0,
            capabilities: [],
            satisfiedCriteria: [],
            challengeProgress: null, // live progress for challenge-gated tiers (tooltip)

            // Email-verification CTA (Tier 2 box in TierProgress)
            verifyModalOpen: false,
            pin: "",
            pinComplete: false,
            verifyError: false,
            codeSent: false,

            // Versioned Terms of Use acceptance. `null` until the user is loaded; a blocking
            // popup is shown whenever termsCurrent is false (accepted version is behind the
            // current one — see server termsConfig.js).
            termsCurrent: null,
            termsSubmitting: false,

            jamSelectedTeam: null,
            jamSelectedTeamName: null,
            passwordEnabled: false,
    };
  }

  //Featured templates shown on Home; fetched lazily by id on click (see openFeaturedTemplate)
  //so Home doesn't need the full public-template list loaded first.
  featuredIds = {
    // Featured template ids are deployment-specific (main vs temp site); see app.config.
    turntaking: appConfig.turntakingTemplateId,
    freeplay: appConfig.freeplayTemplateId,
    cover: appConfig.coverTemplateId,
    brainstorm: appConfig.brainstormTemplateId,
    starter: appConfig.starterTemplateId,
    tutorial: appConfig.tutorialTemplateId,
  }

  //How many more list rows each "Load more" click reveals.
  PAGE_SIZE = 20

  handleMenuClick = (menu) => {
    // The Templates tab is a tier-3 (Host) capability — below that, hosting community/
    // personal templates isn't available, so block access to the tab entirely.
    if(menu === "templates" && !can("create_game_basic", this.state.capabilities)){
      return
    }
    this.setState({
      selectedMenu: menu,
      selectedTeam: null, // <-- show team list
      showCreateTeam: false,
      showInvite: false,
      showMember: false,
    });

    //Lazy-load the tab's data the first time it's opened.
    if(menu === "templates" && !this.state.templatesLoaded && !this.state.templatesLoading){
      this.loadTemplates();
    }
    if(menu === "team" && !this.state.teamsLoaded && !this.state.teamsLoading){
      this.loadTeams();
    }
    if(menu === "hosted" && !this.state.hostedLoaded && !this.state.hostedLoading){
      this.loadHosted();
    }
    if((menu === "recent" || menu === "joined") && !this.state.activityLoaded && !this.state.activityLoading){
      this.loadActivity();
    }
    if(menu === "profile" && !this.state.profileLoaded && !this.state.profileLoading){
      this.loadProfile();
    }
  };

  // Fetch the current user's profile (name.first + avatar) and seed the editable drafts.
  loadProfile = () => {
    const uid = getUserId();
    if(!uid){ return; }
    this.setState({ profileLoading: true });
    this.props.client.query({
      query: GET_USER_PROFILE,
      variables: { _id: uid },
      fetchPolicy: "no-cache",
    }).then((res) => {
      const u = (res && res.data && res.data.userById) || {};
      const first = (u.name && u.name.first) || "";
      this.setState({
        profileLoaded: true,
        profileLoading: false,
        profileAvatar: u.avatar || null,
        profileName: first,
        profileEmail: u.email || "",
        avatarDraft: null,
        nameDraft: first,
      });
    }).catch((err) => {
      console.error("loadProfile failed:", err);
      this.setState({ profileLoading: false });
    });
  };

  // Step 1: the user picks a file -> validate it and open the circular crop dialog.
  handleAvatarPick = (event) => {
    const input = event.target;
    const file = input.files && input.files[0];
    input.value = ""; // allow re-picking the same file
    if(!file){ return; }
    if(!/^image\/(png|jpe?g|webp)$/.test(file.type)){
      alert("Please choose a PNG, JPG or WebP image.");
      return;
    }
    if(file.size > 5 * 1024 * 1024){
      alert("Image must be smaller than 5 MB.");
      return;
    }
    if(this.state.cropImage){ URL.revokeObjectURL(this.state.cropImage); }
    this.setState({ cropImage: URL.createObjectURL(file) });
  };

  closeCrop = () => {
    if(this.state.cropImage){ URL.revokeObjectURL(this.state.cropImage); }
    this.setState({ cropImage: null });
  };

  // Step 2: upload the cropped square to /api/avatar (server makes the 64/128/256 versions)
  // and hold the returned key as a draft until Save Changes.
  handleAvatarCropped = async (blob) => {
    const formData = new FormData();
    formData.append("uid", getUserId());
    formData.append("image", blob, "avatar.jpg");

    const r = await fetch(`${config.backend.uri}/api/avatar`, { method: "POST", body: formData });
    const result = await r.json();
    const key = result && result.data && result.data.avatar && result.data.avatar.key;
    if(!key){ throw new Error((result && result.error) || "Invalid upload response"); }
    this.closeCrop();
    this.setState({ avatarDraft: key });
  };

  saveAvatar = () => {
    const uid = getUserId();
    if(!uid || !this.state.avatarDraft){ return; }
    this.props.client.mutate({
      mutation: USER_UPDATE_PROFILE,
      variables: { _id: uid, avatar: this.state.avatarDraft },
    }).then((res) => {
      const u = (res && res.data && res.data.userUpdateProfile) || {};
      const saved = u.avatar || this.state.avatarDraft;
      this.setState({ profileAvatar: saved, avatarDraft: null });
      EE.emit("Avatar updated", saved);
    }).catch((err) => {
      console.error("saveAvatar failed:", err);
      alert("Failed to save avatar.");
    });
  };

  cancelAvatar = () => this.setState({ avatarDraft: null });

  saveName = () => {
    const uid = getUserId();
    if(!uid){ return; }
    this.props.client.mutate({
      mutation: USER_UPDATE_PROFILE,
      variables: { _id: uid, first: this.state.nameDraft },
    }).then((res) => {
      const u = (res && res.data && res.data.userUpdateProfile) || {};
      const first = (u.name && u.name.first) || this.state.nameDraft;
      this.setState({ profileName: first, nameDraft: first });
    }).catch((err) => {
      console.error("saveName failed:", err);
      alert("Failed to save nickname.");
    });
  };

  cancelName = () => this.setState({ nameDraft: this.state.profileName });

  // Collapse the password form back to the Reset Password button and clear its fields.
  cancelPasswordChange = () => this.setState({
    showPasswordForm: false,
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
    passwordMsg: null,
  });

  changePassword = () => {
    const uid = getUserId();
    const { currentPassword, newPassword, confirmPassword } = this.state;

    if(!currentPassword || !newPassword){
      this.setState({ passwordMsg: { type: "error", text: "Please fill in all password fields." } });
      return;
    }
    if(newPassword.length < 6){
      this.setState({ passwordMsg: { type: "error", text: "New password must be at least 6 characters." } });
      return;
    }
    if(newPassword !== confirmPassword){
      this.setState({ passwordMsg: { type: "error", text: "New password and confirmation do not match." } });
      return;
    }

    this.props.client.mutate({
      mutation: USER_CHANGE_PASSWORD,
      variables: { _id: uid, currentPassword, newPassword },
    }).then(() => {
      this.setState({
        showPasswordForm: false,
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
        passwordMsg: { type: "success", text: "Password changed successfully." },
      });
    }).catch((err) => {
      const raw = (err && err.message) || "";
      let text = "Failed to change password.";
      if(raw.includes("INCORRECT_PASSWORD")){ text = "Current password is incorrect."; }
      else if(raw.includes("WEAK_PASSWORD")){ text = "New password must be at least 6 characters."; }
      this.setState({ passwordMsg: { type: "error", text } });
    });
  };


    // Open the verify modal and auto-send a fresh code. Works for every cohort: legacy
    // users with verification:null get their first code, others get a fresh one (the
    // server no-ops if already verified and has a cooldown against spam).
    openVerifyModal = () => {
        this.setState({ verifyModalOpen: true, pin: "", pinComplete: false, verifyError: false, codeSent: false });
        this.sendVerificationCode();
    };

    sendVerificationCode = () => {
        this.props.client.mutate({
            mutation: USER_RESEND_VERIFICATION,
            variables: { _id: this.state.uid },
        }).then(() => {
            this.setState({ codeSent: true });
        }).catch((err) => {
            console.log("Resend verification failed:", err);
        });
    };

    // Submit the entered code to the authoritative verifyEmail mutation. On success the
    // server sets verified + recomputes the tier; we refetch access/capabilities so the
    // dashboard unlocks immediately, and close the modal.
    handleVerifyEmail = () => {
        this.props.client.mutate({
            mutation: USER_VERIFY_EMAIL,
            variables: {
                _id: this.state.uid,
                code: this.state.pin,
            },
        }).then(() => {
            this.setState({ verifyModalOpen: false, pin: "", pinComplete: false, verifyError: false });
            this.jamPageQuery(this.state.uid); // refresh tier/capabilities
        }).catch((err) => {
            console.log("Email verification failed:", err);
            this.setState({ verifyError: true });
        });
    };

    // Verification dialog — reuses the PinInput code-entry from registration.js.
    renderVerifyModal = () => {
        return (
            <Modal
                open={this.state.verifyModalOpen}
                onClose={() => this.setState({ verifyModalOpen: false })}
                style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
                <div style={{ background: "#fff", padding: "40px", borderRadius: "8px", width: "400px", textAlign: "center", fontFamily: "arial", outline: "none" }}>
                    <div style={{ fontWeight: "bold", fontSize: "1rem", marginBottom: "10px" }}>
                        Verify your email
                    </div>
                    <p style={{ fontSize: "0.85rem", color: "#4F4F4F" }}>
                        {this.state.codeSent ? "Enter the 6-digit code we sent to" : "Sending a 6-digit code to"} <br/><strong>{getEmail()}</strong>
                    </p>
                    <form onSubmit={(e) => { e.preventDefault(); }} noValidate autoComplete="off">
                        <PinInput
                            length={6}
                            initialValue=""
                            onChange={(value) => { if (value.length < 6) { this.setState({ pinComplete: false }); } this.setState({ pin: value, verifyError: false }); }}
                            onComplete={() => { this.setState({ pinComplete: true }); }}
                            type="numeric"
                            inputMode="numeric"
                            style={{ padding: "10px", display: "flex", justifyContent: "center", flexWrap: "nowrap" }}
                            inputStyle={{ borderColor: "lightgray", borderWidth: "2px", borderRadius: "5px", backgroundColor: "white", fontSize: "20px", width: "40px", height: "50px", margin: "0 3px" }}
                            inputFocusStyle={{ borderColor: "blue" }}
                            autoSelect={true}
                        />
                        {this.state.verifyError &&
                            <p style={{ color: "#E53935", fontSize: "0.8rem" }}>That code doesn't match. Please try again.</p>
                        }
                        <div>
                            <br/>
                            <Button
                                type="submit"
                                disabled={!this.state.pinComplete}
                                onClick={this.handleVerifyEmail}
                                style={{ width: "15rem", color: "white", background: !this.state.pinComplete ? "#D1D1D1" : "#FDAF2A" }}
                            >
                                VERIFY
                            </Button>
                        </div>
                        <p style={{ textAlign: "center", marginTop: "10px", fontSize: "0.8rem", color: "#4F4F4F" }}>
                            No email in your inbox or spam folder?
                            <Link
                                onClick={this.sendVerificationCode}
                                style={{ cursor: "pointer", marginLeft: "5px", fontWeight: "bold", color: "#E97610" }}
                            >
                                Resend code
                            </Link>
                        </p>
                    </form>
                </div>
            </Modal>
        );
    };

    // Persist the user's acceptance of the terms, then clear the blocking popup.
    handleAcceptTerms = () => {
        const uid = this.state.uid || getUserId();
        if (!uid) { return; }
        this.setState({ termsSubmitting: true });
        this.props.client.mutate({
            mutation: USER_ACCEPT_TERMS,
            variables: { _id: uid },
        }).then(() => {
            this.setState({ termsCurrent: true, termsSubmitting: false });
        }).catch((err) => {
            console.log("Accept terms failed:", err);
            this.setState({ termsSubmitting: false });
        });
    };

    // Blocking terms & privacy popup for pre-existing users who haven't accepted yet.
    // Cannot be dismissed by backdrop click or Escape — only "Agree" clears it.
    renderTermsModal = () => {
        const show = this.state.termsCurrent === false;
        return (
            <Modal
                open={show}
                disableBackdropClick
                disableEscapeKeyDown
                style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
                <div style={{ background: "#fff", padding: "0", borderRadius: "8px", width: "420px", maxWidth: "90%", textAlign: "center", fontFamily: "arial", outline: "none", overflow: "hidden" }}>
                    <div style={{ fontWeight: "bold", fontSize: "1.4rem", color: "#4F4F4F", padding: "24px", borderBottom: "1px solid #EEE" }}>
                        Updated Terms of Use
                    </div>
                    <div style={{ padding: "32px 40px 40px 40px" }}>
                        <div style={{ marginBottom: "16px" }}>
                            <img src={termsIcon} alt="Terms" style={{ height: "72px", width: "auto" }} />
                        </div>
                        <p style={{ fontSize: "1.25rem", color: "#4F4F4F", fontWeight: "500", margin: "0 0 20px 0", lineHeight: "1.4" }}>
                            Action Required. To continue using this tool, you must agree to the updated Terms of Use
                        </p>
                        <p style={{ fontSize: "0.85rem", color: "#828282", margin: "0 0 28px 0", lineHeight: "1.5" }}>
                            By clicking <strong>Agree and Continue</strong>, you accept our updated{" "}
                            <Link href="/terms" target="_blank" rel="noopener noreferrer" style={{ fontWeight: "bold", color: "#E97610" }}>Terms of Use</Link>
                        </p>
                        <Button
                            onClick={this.handleAcceptTerms}
                            disabled={this.state.termsSubmitting}
                            style={{ width: "100%", color: "white", background: "#E97610", fontWeight: "bold", padding: "12px 0", fontSize: "1rem" }}
                        >
                            {this.state.termsSubmitting ? "Saving..." : "AGREE AND CONTINUE"}
                        </Button>
                    </div>
                </div>
            </Modal>
        );
    };

    TierProgress() {
        // Data-driven off the shared tier journey (utility/permissions). Each tier lists
        // several criteria; a tier is "unlocked" only when the server has recorded ALL of
        // them in satisfiedCriteria (mirrors the sequential server ladder).
        const icons = [waving, hat, input_bp, hat];
        const satisfied = this.state.satisfiedCriteria;
        const cp = this.state.challengeProgress;

        const steps = TIER_STEPS.map((s, i) => ({
            tier: s.tier,
            level: `Tier ${s.tier}`,
            name: s.name,
            icon: icons[i % icons.length],
            criteria: s.criteria,
            unlocked: s.criteria.every((cid) => hasCriterion(cid, satisfied)),
        }));

        // Tooltip: list each criterion (✓/○) and, for challenge criteria, their live
        // sub-tasks. Live numbers show only when challengeProgress belongs to that
        // criterion's template (the single slot reflects only the most recent attempt).
        // One sub-task row (checkmark + wrapping label + optional right-aligned value).
        const renderSubRow = (key, done, label, value) => (
            <div key={key} style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "8px", fontSize: "11px", lineHeight: "1.5", paddingLeft: "14px", opacity: 0.9 }}>
                <span style={{ flex: "1 1 auto", minWidth: 0, overflowWrap: "anywhere" }}>{done ? "✓" : "○"} {label}</span>
                {value !== "" &&
                    <span style={{ flex: "0 0 auto", whiteSpace: "nowrap", opacity: 0.85 }}>{value}</span>
                }
            </div>
        );

        const renderTip = (step) => (
            <div style={{ padding: "2px 0", minWidth: "200px", maxWidth: "260px" }}>
                <div style={{ fontWeight: "bold", marginBottom: "4px" }}>
                    {step.unlocked ? "Completed" : "To unlock:"}
                </div>
                {step.criteria.map((cid) => {
                    // Presentation only (no behaviour change): when a tier requires both
                    // canvas_setup_used and starter_host (Tier 3), show "Try Canvas set-up"
                    // nested under the Starter-jam task instead of as its own top-level line.
                    if (cid === "canvas_setup_used" && step.criteria.indexOf("starter_host") !== -1) {
                        return null;
                    }
                    const cdone = hasCriterion(cid, satisfied);
                    const target = targetFor(cid);
                    const prog = (cp && cp.builderID === target) ? cp : null;
                    const subs = subtasksFor(cid);
                    const injectCanvas = (cid === "starter_host" && step.criteria.indexOf("canvas_setup_used") !== -1);
                    return (
                        <div key={cid} style={{ marginBottom: "3px" }}>
                            <div style={{ fontSize: "12px", fontWeight: "bold", overflowWrap: "anywhere" }}>
                                {cdone ? "✓" : "○"} {labelFor(cid)}
                            </div>
                            {subs.map((t, idx) => {
                                const done = cdone || t.done(prog);
                                return (
                                    <React.Fragment key={idx}>
                                        {renderSubRow(`sub-${idx}`, done, t.label, t.value(prog))}
                                        {/* After "Host a Starter jam (as the creator)" (first sub-task),
                                            nest the Canvas set-up status (its own criterion). */}
                                        {injectCanvas && idx === 0 &&
                                            renderSubRow("canvas-setup", hasCriterion("canvas_setup_used", satisfied), labelFor("canvas_setup_used"), "")}
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    );
                })}
                {/* Tutorial video link (tiers 2–5). The tooltip is interactive so the user can
                    move from the box into the tooltip and click this without it closing. */}
                {step.tier >= 2 &&
                    <div style={{ marginTop: "6px", paddingTop: "6px", borderTop: "1px solid rgba(255,255,255,0.25)" }}>
                        <a
                            href={`https://jamtaiyaki.notion.site/tier-${step.tier}-tutorial-video`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ fontSize: "12px", color: "#90caf9", textDecoration: "underline" }}
                        >
                            ▶ Watch tutorial video here
                        </a>
                    </div>
                }
            </div>
        );

    return (
        <div
        style={{
            display: "flex",
            gap: "10px",
            justifyContent: "center",
            marginTop: "20px",
        }}
        >
        {steps.map((step, index) => {
            const box = (
            <div
            style={{
                flex: "1",
                minWidth: "220px",
                padding: "12px",
                borderRadius: "6px",
                backgroundColor: step.unlocked ? "#d4f8d4" : "#f0f0f0",
                color: step.unlocked ? "#000" : "#666",
                display: "flex",
                alignItems: "center",
                border: "1px solid #ccc",
                cursor: "pointer",
            }}
            >
            {/* Icon */}
            <img
                src={step.icon}
                alt={step.level}
                style={{ width: "30px", height: "30px", marginRight: "10px" }}
            />

            {/* Texts inline */}
            <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ fontWeight: "bold", fontSize: "14px" }}>
                {`${step.level} — ${step.name}`}
                </div>
                <div style={{ fontSize: "12px" }}>
                    {step.criteria.map((cid) => labelFor(cid)).join(" · ")}
                </div>
            </div>
            </div>
            );

            return (
                <Tooltip key={index} interactive arrow placement="top" title={renderTip(step)}>
                    {box}
                </Tooltip>
            );
        })}
        </div>
    );

    }


    progressBar = () => {
        const steps = [
            { label: "Hosted a jam", icon: waving },
            { label: "Earned top contributor", icon: hat },
            { label: "Next milestone", icon: input_bp},
        ];

        //console.log(this.state.access)
        const currentStep = this.state.access; // 0-based index of progress

        return (
            <div
            style={{
                display: "flex",
                alignItems: "center",
                width: "800px",
                margin: "20px 0",
            }}
            >
            {steps.map((step, index) => (
                <React.Fragment key={index}>
                {/* Step Icon */}
                <div
                    style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "8px",
                    border: index < currentStep ? "2px solid #4caf50" : "2px solid #4f4f4f",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: index < currentStep ? "#c9f3cd" : "#e0e0e0",
                    zIndex: 2,
                    }}
                >
                    <img
                    src={step.icon}
                    alt={step.label}
                    style={{ width: "30px", height: "30px" }}
                    />
                </div>

                {/* Bar (only render if not last step) */}
                {index < steps.length - 1 && (
                    <div
                    style={{
                        flex: 1,
                        height: "30px",
                        //margin: "0 8px",
                        // borderRadius: "6px",
                        backgroundColor: index < currentStep-1 ? "#d4af37" : "#e0e0e0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#333",
                        fontSize: "14px",
                        fontWeight: "500",
                    }}
                    >
                    {step.label}
                    </div>
                )}
                </React.Fragment>
            ))}
            </div>
        );
    }

  renderHome = () => {
    const {classes} = this.props
    return(
      <Grid container spacing={4} className={classes.container}>
            <Grid item xs={12}>
                {/* BANNER */}
                {/* <img 
                  onClick={()=>{
                    window.location.href = `/event/workshop`;
                  }} 
                  alt="banner" className={classes.banner} src={require('../../../element/2026/dndbanner.png')}/> */}
                {/* FEATURED GAME JAM ROW */}       
                {/* Access */}

                <Card className={`${classes.card} ${classes.cardHeaderContainer}`} style={{marginBottom:"-15px"}}>
                    <Grid container >
                        <Grid item xs={12} className={classes.cardHeader}>
                        Access
                        </Grid>
                    </Grid>
                </Card>
                <Card className={classes.card} style={{background:"transparent", border:"none", marginTop:"15px"}}>
                    
                        {this.TierProgress()}
                    
                </Card>
                {/* HOST OR BUILD FROM JAMIT TEMPLATES */}
                <Card className={`${classes.card} ${classes.cardHeaderContainer}`} style={{marginBottom:"-15px"}}>
                    <Grid container >
                        <Grid item xs={12} className={classes.cardHeader}>
                            Starter &amp; Jammer: Guided Templates
                        </Grid>
                    </Grid>
                </Card>

                {/* QUICK START WITH JAM TEMPLATES */}
                <Card className={classes.card} style={{background:"transparent", border:"none", marginTop:"15px"}}>
                    <Grid container spacing={2}>
                        <Grid item xs={5}>
                            <Grid
                                container
                                justify="center"
                                alignItems="center"
                                spacing={0}
                                className={classes.displayBox}
                                style={{filter: !can("host_tutorial", this.state.capabilities) ? "grayscale(100%)": "none"}}
                                onClick={()=>{
                                    if(!can("host_tutorial", this.state.capabilities)){
                                        return
                                    }
                                    // this.setState({
                                    //     dialogOpen: true,
                                    //     selectedJB:{
                                    //         type: "story"
                                    //     }
                                    // });

                                    this.openFeaturedTemplate(this.featuredIds.tutorial, {tutorial: true})
                                }}
                            >
                                <Grid item xs={4} style={{background:"#2CB67D",borderRadius:"10px 0 0 10px",height:"120px",display:"flex",alignItems:"center",justifyContent:"center"}}>
                                    <img alt="icon" className={classes.displayImg} style={{height:"85px",position:"static"}} src={require('../../../element/2024aug/zoom_gesture.png')}/>
                                </Grid>

                                <Grid item xs={8} className={classes.displayBg} style={{borderRadius:"0px 10px 10px 0px",background:"#C9F3CD",border:"1px solid #C9F3CD",display:"flex",flexDirection:"column",justifyContent:"center"}}>
                                    <div className={classes.displayTitleWrapper} style={{marginLeft:"20px"}}>
                                        <p className={classes.displayTitle}>TUTORIAL JAM</p>
                                        <p className={classes.displaySubTitle}>Learn to jam as you go thru a journey</p>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={5}>
                            <Grid
                                container
                                justify="center"
                                alignItems="center"
                                spacing={0}
                                className={classes.displayBox}
                                style={{filter: !can("create_game_starter", this.state.capabilities) ? "grayscale(100%)": "none"}}
                                onClick={()=>{

                                    if(!can("create_game_starter", this.state.capabilities)){
                                        return
                                    }

                                    this.openFeaturedTemplate(this.featuredIds.starter, {starter: true})
                                }}
                            >
                                <Grid item xs={4} style={{background:"#2CB67D",borderRadius:"10px 0 0 10px",height:"120px",display:"flex",alignItems:"center",justifyContent:"center"}}>
                                    <img alt="icon" className={classes.displayImg} style={{height:"85px",position:"static"}} src={require('../../../element/2026/milestone.png')}/>
                                </Grid>
                                <Grid item xs={8} className={classes.displayBg} style={{borderRadius:"0px 10px 10px 0px",background:"#C9F3CD",border:"1px solid #C9F3CD",display:"flex",flexDirection:"column",justifyContent:"center"}}>
                                    <div className={classes.displayTitleWrapper} style={{marginLeft:"20px"}}>
                                        <p className={classes.displayTitle}>STARTER JAM</p>
                                        <p className={classes.displaySubTitle}>Freestyle guided<br/>ideation</p>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Card>

                {/* CREATE YOUR OWN SECTION */} 
                <Card className={`${classes.card} ${classes.cardHeaderContainer}`} style={{marginBottom:"-15px"}}>
                    <Grid container >
                        <Grid item xs={12} className={classes.cardHeader}>
                        Host a jam from template
                        </Grid>
                    </Grid>
                </Card>
                <Card className={classes.card} style={{background:"transparent", border:"none", marginTop:"15px"}}>
                    <Grid container spacing={2}>
                            <Grid item xs={5}>
                                <Grid
                                    container
                                    justify="center"
                                    alignItems="center"
                                    spacing={0}
                                    className={classes.displayBox}
                                    //disable={parseInt("1")}
                                    style={{filter: !can("create_game_advanced", this.state.capabilities) ? "grayscale(100%)": "none"}}
                                    onClick={()=>{
                                        // this.setState({
                                        //     dialogOpen: true,
                                        //     selectedJB:{
                                        //         type: "brainstorm"
                                        //     }
                                        // });
                                        // console.log(this.state.access)
                                        if(!can("create_game_advanced", this.state.capabilities)){
                                            return
                                        }

                                        this.openFeaturedTemplate(this.featuredIds.brainstorm, {brainstorm: true})
                                    }}
                                >
                                    <img alt="icon" className={classes.displayImg} style={{marginLeft:"2em",height:"80px",top:"20px"}} src={require('../../../element/2024aug/intellectual.png')}/>
                                    <div className={classes.displayBg}>
                                        <div className={classes.displayTitleWrapper} style={{marginTop:"5%"}}>
                                            <p className={classes.displayTitle}>BRAINSTORM JAM</p>
                                            <p className={classes.displaySubTitle}>Quick and process<br/>oriented</p>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid item xs={5}>
                                <Grid
                                    container
                                    justify="center"
                                    alignItems="center"
                                    spacing={0}
                                    className={classes.displayBox}
                                    style={{filter: !can("create_game_advanced", this.state.capabilities) ? "grayscale(100%)": "none"}}
                                    onClick={()=>{
                                        if(!can("create_game_advanced", this.state.capabilities)){
                                            return
                                        }
                                        this.openFeaturedTemplate(this.featuredIds.cover, {cover: true})
                                    }}
                                >
                                    <img alt="icon" className={classes.displayImg} style={{marginLeft:"3.5em",height:"80px",top:"20px"}} src={require('../../../element/2024aug/painting_board.png')}/>
                                    <div className={classes.displayBg}>
                                        <div className={classes.displayTitleWrapper} style={{marginTop:"5%"}}>
                                            <p className={classes.displayTitle}>COVER JAM</p>
                                            <p className={classes.displaySubTitle}>Don't judge a book by<br/>its cover</p>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                    </Grid>
                </Card>
            </Grid>
      </Grid>
    )
  }

  renderTemplates = () => {
    const {classes} = this.props
    // console.log(this.state.recentActivity)
    return (
      <Grid container spacing={4}>
        {/* Level 1 */}
        <Grid item xs={12}>
            {/* QUICK START WITH JAM TEMPLATES */}
            <Card className={classes.card} style={{background:"transparent", border:"none", marginTop:"15px"}}>
                <Grid container spacing={2}>
                    <Grid item xs={5}>
                      <Tooltip arrow title={!can("create_game_basic", this.state.capabilities) ? hintFor("create_game_basic") : ""}>
                        <Grid
                            container
                            justify="center"
                            alignItems="center"
                            spacing={0}
                            className={classes.displayBox}
                            style={{filter: !can("create_game_basic", this.state.capabilities) ? "grayscale(100%)": "none", cursor: !can("create_game_basic", this.state.capabilities) ? "not-allowed" : "pointer"}}
                            onClick={()=>{
                                if(!can("create_game_basic", this.state.capabilities)){
                                    return
                                }
                                this.openFeaturedTemplate(this.featuredIds.turntaking, {turntaking: true});
                            }}
                        >
                            <Grid item xs={4} style={{background:"#74bfc9",borderRadius:"10px 0 0 10px",height:"120px",display:"flex",alignItems:"center",justifyContent:"center"}}>
                                <img alt="icon" className={classes.displayImg} style={{height:"85px",position:"static"}} src={require('../../../element/2024aug/user_switch.png')}/>
                            </Grid>

                            <Grid item xs={8} className={classes.displayBg} style={{borderRadius:"0px 10px 10px 0px",background:"#faf7ea",border:"1px solid #faf7ea",display:"flex",flexDirection:"column",justifyContent:"center"}}>
                                <div className={classes.displayTitleWrapper} style={{marginLeft:"20px"}}>
                                    <p className={classes.displayTitle}>TURN-TAKING</p>
                                    <p className={classes.displaySubTitle}>Each player gets a turn in<br/>sequential order</p>
                                </div>
                            </Grid>
                        </Grid>
                      </Tooltip>
                    </Grid>
                    <Grid item xs={5}>
                      <Tooltip arrow title={!can("create_game_basic", this.state.capabilities) ? hintFor("create_game_basic") : ""}>
                        <Grid
                            container
                            justify="center"
                            alignItems="center"
                            spacing={0}
                            className={classes.displayBox}
                            style={{filter: !can("create_game_basic", this.state.capabilities) ? "grayscale(100%)": "none", cursor: !can("create_game_basic", this.state.capabilities) ? "not-allowed" : "pointer"}}
                            onClick={()=>{

                                if(!can("create_game_basic", this.state.capabilities)){
                                    return
                                }

                                this.openFeaturedTemplate(this.featuredIds.freeplay, {freeplay: true})
                            }}
                        >
                            <Grid item xs={4} style={{background:"#74bfc9",borderRadius:"10px 0 0 10px",height:"120px",display:"flex",alignItems:"center",justifyContent:"center"}}>
                                <img alt="icon" className={classes.displayImg} style={{height:"85px",position:"static"}} src={require('../../../element/2024aug/zoom_gesture.png')}/>
                            </Grid>
                            <Grid item xs={8} className={classes.displayBg} style={{borderRadius:"0px 10px 10px 0px",background:"#faf7ea",border:"1px solid #faf7ea",display:"flex",flexDirection:"column",justifyContent:"center"}}>
                                <div className={classes.displayTitleWrapper} style={{marginLeft:"20px"}}>
                                    <p className={classes.displayTitle}>FREE PLAY</p>
                                    <p className={classes.displaySubTitle}>Player free to engage<br/>without set turns</p>
                                </div>
                            </Grid>
                        </Grid>
                      </Tooltip>
                    </Grid>
                </Grid>
            </Card>

            {/* CREATE YOUR OWN SECTION */}
            <Card className={`${classes.card} ${classes.cardHeaderContainer}`} style={{marginBottom:"-15px"}}>
                <Grid container >
                    <Grid item xs={12} className={classes.cardHeader}>
                     Host a jam from template
                    </Grid>
                </Grid>
            </Card>
            <Card className={classes.card} style={{background:"transparent", border:"none", marginTop:"15px"}}>
                <Grid container spacing={2}>
                        <Grid item xs={5}>
                            <Grid
                                container
                                justify="center"
                                alignItems="center"
                                spacing={0}
                                className={classes.displayBox}
                                //disable={parseInt("1")}
                                style={{filter: !can("create_game_advanced", this.state.capabilities) ? "grayscale(100%)": "none"}}
                                onClick={()=>{
                                    // this.setState({
                                    //     dialogOpen: true,
                                    //     selectedJB:{
                                    //         type: "brainstorm"
                                    //     }
                                    // });
                                    // console.log(this.state.access)
                                    if(!can("create_game_advanced", this.state.capabilities)){
                                        return
                                    }

                                    this.openFeaturedTemplate(this.featuredIds.brainstorm, {brainstorm: true})
                                }}
                            >
                                <img alt="icon" className={classes.displayImg} style={{marginLeft:"2em",height:"80px",top:"20px"}} src={require('../../../element/2024aug/intellectual.png')}/>
                                <div className={classes.displayBg}>
                                    <div className={classes.displayTitleWrapper} style={{marginTop:"5%"}}>
                                        <p className={classes.displayTitle}>BRAINSTORM JAM</p>
                                        <p className={classes.displaySubTitle}>Quick and process<br/>oriented</p>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                        <Grid item xs={5}>
                            <Grid
                                container
                                justify="center"
                                alignItems="center"
                                spacing={0}
                                className={classes.displayBox}
                                style={{filter: !can("create_game_advanced", this.state.capabilities) ? "grayscale(100%)": "none"}}
                                onClick={()=>{
                                    if(!can("create_game_advanced", this.state.capabilities)){
                                        return
                                    }
                                    this.openFeaturedTemplate(this.featuredIds.cover, {cover: true})
                                }}
                            >
                                <img alt="icon" className={classes.displayImg} style={{marginLeft:"3.5em",height:"80px",top:"20px"}} src={require('../../../element/2024aug/painting_board.png')}/>
                                <div className={classes.displayBg}>
                                    <div className={classes.displayTitleWrapper} style={{marginTop:"5%"}}>
                                        <p className={classes.displayTitle}>COVER JAM</p>
                                        <p className={classes.displaySubTitle}>Don't judge a book by<br/>its cover</p>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                </Grid>
            </Card>
            <div style={{marginBottom:"4em"}}>

            </div>
        </Grid>

        {/* MY TEMPLATES */}
        <Grid item xs={12}>
            <p style={{fontWeight:"bold", fontSize:"16px", color:"#4F4F4F", marginBottom:"10px"}}>My Templates</p>
            {this.state.templatesLoading
              ? this.renderLoader()
              : this.renderTemplateTable(this.state.jambuilders, this.state.myTemplatesHasMore, this.loadMoreMyTemplates, this.state.myTemplatesLoadingMore)}
        </Grid>

        {/* TEMPLATES BY COMMUNITY (temp site: admin-curated "Featured Community Templates") */}
        <Grid item xs={12}>
            <p style={{fontWeight:"bold", fontSize:"16px", color:"#4F4F4F", marginBottom:"10px", marginTop:"20px"}}>{appConfig.isTempSite ? "Featured Community Templates" : "Templates by Community"}</p>
            {this.state.templatesLoading
              ? this.renderLoader()
              : this.renderTemplateTable(this.state.publicJambuilders, this.state.communityHasMore, this.loadMoreCommunity, this.state.communityLoadingMore)}
        </Grid>
      </Grid>
    );
  };

  removeMember = (uid) => {
    const {teams,selectedTeam} = this.state
    const team = teams.find(t => t._id === selectedTeam);
    console.log(team,uid);

    this.props.client.mutate({
      mutation: TEAM_DELETE_MEMBERS,
      variables: {
        teamId: team._id,
        memberId: uid,
      }
    }).then((res)=>{
        let index = teams.findIndex(t => t._id === selectedTeam);
        let newTeam = JSON.parse(JSON.stringify(teams))
        newTeam[index].members = res.data.teamDeleteMember.members

        this.setState({
          teams: newTeam,
        })
    })

    
  }


  inviteMember = (members) => {
    const {teams,selectedTeam} = this.state
    const team = teams.find(t => t._id === selectedTeam);
    
    this.props.client.mutate({
        mutation: TEAM_ADD_MEMBERS,
        variables: {
          _id : team._id,
          members: members,
        }
    }).then((res)=>{
      
      let index = teams.findIndex(t => t._id === selectedTeam);
      let newTeam = JSON.parse(JSON.stringify(teams))
      newTeam[index].members = res.data.teamAddMember.members

      this.setState({
        teams: newTeam,
        showInvite: false,
      })

      // this.setState((prev)=>({
      //   teams: [prev.teams, res.data.teamAddMember],
      //   showInvite: false,
      // }))
    })

    //this.setState({showInvite: false})
  }

  userByEmail = async (email) => {
    try {
      const res = await this.props.client.query({
        query: GET_USER_BY_EMAIL_SINGLE,
        variables: { email }
      });
      return res.data; // <-- NOW it returns!
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  handleAccept = (e, team) => {
    e.stopPropagation(); // Prevent row click event
    // Add your accept logic here
    console.log('Accepted team:', team);
    let uid = getUserId()
    // Example: call API to accept team
    // this.props.onAcceptTeam(team._id);
    this.props.client.mutate({
      mutation: TEAM_MEMBER_APPROVE,
      variables: {
        teamId: team._id,
        memberId: uid,
        approve: true,
      }
    }).then((res)=>{
      const {teams,selectedTeam} = this.state
      let index = teams.findIndex(t => t._id === res.data.teamMemberApprove._id);
      let newTeam = JSON.parse(JSON.stringify(teams))
      newTeam[index].members = res.data.teamMemberApprove.members

      this.setState({
        teams: newTeam,
      })
      // Accepting a team invite makes the user a team member -> tier 2. Refresh so the
      // newly-unlocked features appear without a manual reload.
      this.refreshTierAccess()
    })
  }

  // Re-fetch the user's tier/capabilities after a change that can affect them (e.g.
  // creating or joining a team). Updates the dashboard's own gating state and the
  // app-wide provider used by route guards.
  refreshTierAccess = () => {
    const uid = getUserId()
    if(!uid){ return }
    // Use the authoritative evaluate mutation (it awaits the server recompute), so we
    // don't read a stale tier from a plain query that races the team trigger.
    this.props.client.mutate({
      mutation: USER_EVALUATE_TIER,
      variables: { _id: uid },
    }).then((res) => {
      const u = (res && res.data && res.data.userEvaluateTier) || {}
      this.setState({
        access: u.access,
        capabilities: u.capabilities || [],
        satisfiedCriteria: u.satisfiedCriteria || [],
        challengeProgress: u.challengeProgress || null,
      })
    }).catch((err) => console.log("refreshTierAccess failed:", err))
    // Also refresh the app-wide provider used by route guards (/jambuilder, /deckbuilder).
    if(this.context && this.context.refresh){ this.context.refresh() }
  }

  handleDecline = (e, team) => {
    e.stopPropagation(); // Prevent row click event
    // Add your decline logic here
    console.log('Declined team:', team);
    let uid = getUserId()
    // Example: call API to decline team
    // this.props.onDeclineTeam(team._id);
    this.props.client.mutate({
      mutation: TEAM_MEMBER_APPROVE,
      variables: {
        teamId: team._id,
        memberId: uid,
        approve: false,
      }
    }).then((res)=>{
      const {teams,selectedTeam} = this.state
      let index = teams.findIndex(t => t._id === res.data.teamMemberApprove._id);
      let newTeam = JSON.parse(JSON.stringify(teams))
      newTeam[index].members = res.data.teamMemberApprove.members

      this.setState({
        teams: newTeam,
      })
    })
  }

  renderStatusCell = (team) => {
    const { classes } = this.props;
    let uid = getUserId()
    let user = team.members.find((n)=>{return n.user._id === uid})
    // console.log(team, user)
    
    if (user.status === "pending") {
      return (
        <Box>
          <Button
            size="small"
            className={classes.declineButton}
            onClick={(e) => this.handleDecline(e, team)}
          >
            Decline
          </Button>
          <Button
            size="small"
            className={classes.acceptButton}
            onClick={(e) => this.handleAccept(e, team)}
          >
            Accept
          </Button>
        </Box>
      );
    }
    
    return user.status || "Active";
  }
 
  renderMemberAction = (member) => {
    //console.log(member)
    //console.log("Selected Team:", this.state.selectedTeamData)
    const { classes } = this.props;
    let uid = getUserId()
    let isLeader = false

    if(uid === this.state.selectedTeamData.createdBy._id){
      isLeader = true
    }

    if(isLeader){
      //console.log("leader")
      if(member.user._id === uid){
        return "Host"
      }else{
        return(
          <Button
            size="small"
            className={classes.declineButton}
            onClick={(e) => {
                // console.log('remove')
                this.removeMember(member.user._id)
              }
            }
          >
            Remove
          </Button>
        )
      }
    }else{
      //console.log("non leader")
      if(member.user._id === uid){
        //console.log("its me")
          return(
            <Button
              size="small"
              className={classes.declineButton}
              onClick={(e) => {
                // console.log('remove self')
                this.removeMember(uid)
              }}
            >
              Leave
            </Button>
          )
      }else{
        return ""
      }
    }

  }



  renderTeam = () => {
    const { showCreateTeam, teams, selectedTeam, selectedMenu } = this.state;

    // console.log(teams)

    // 🧩 0️⃣ Team List View
    if (selectedMenu === "team" && !selectedTeam && !showCreateTeam) {
      const { teams } = this.state;

      return (
        <Box sx={{ p: 5 }}>
          {/* Header with + TEAM button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Your Teams
            </Typography>

            <Button
              variant="contained"
              style={{
                backgroundColor: "#4CAF50", // green button
                color: "#fff",
                textTransform: "none",
                fontWeight: "bold",
                "&:hover": { backgroundColor: "#45a049" },
              }}
              onClick={() => this.setState({ showCreateTeam: true, selectedTeam: null })}
              
            >
              + TEAM
            </Button>
          </Box>

          {teams.length === 0 ? (
            <Typography>No teams created yet.</Typography>
          ) : (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Team Name</TableCell>
                    <TableCell>Member</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Created By</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {teams.map((team, i) => (
                    <TableRow
                      key={i}
                      hover
                      sx={{ cursor: "pointer" }}
                      onClick={() => { this.setState({ selectedTeam: team._id, selectedTeamData: team }); this.loadTeamTemplates(team); }}
                    >
                      <TableCell>{team.name}</TableCell>
                      <TableCell>{team.members?.length || 0}</TableCell>
                      <TableCell>{this.renderStatusCell(team)}</TableCell>
                      <TableCell>{team.createdBy.name.first || "You"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      );
    }



    // 🧩 3️⃣ Team detail view
    if (selectedTeam) {
      const team = teams.find(t => t._id === selectedTeam);
      const mockJams = [
        { name: "Ep 1: Introduction", members: 1, status: "Jamming", createdBy: "Tina" },
        { name: "Ep 2: Meet Cranston family", members: 5, status: "Waiting Room", createdBy: "Tina" },
      ];

      // Mock team members
        const mockMembers = [
        {
            id: 1,
            name: "Alice Johnson",
            joined: "2024-12-01",
            status: "Pending",
        },
        {
            id: 2,
            name: "Bob Lee",
            joined: "2025-01-15",
            status: "Pending",
        },
        {
            id: 3,
            name: "Charlie Kim",
            joined: "2025-03-08",
            status: "Pending",
        },
        {
            id: 4,
            name: "Dana Smith",
            joined: "2025-06-20",
            status: "Pending",
        },
        ];


      if(this.state.showMember){
            return (
      <div
        style={{
          backgroundColor: "#f7f7f7",
          borderRadius: "12px",
          padding: "30px",
          minHeight: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "25px",
          }}
        >
          <h3 style={{ margin: 0 }}>Team › {team.name} › Members</h3>
          <button
            onClick={() => this.setState({ showMember: false })}
            style={{
              border: "1px solid #aaa",
              background: "transparent",
              borderRadius: "6px",
              padding: "6px 14px",
              cursor: "pointer",
            }}
          >
            Back to Team
          </button>
        </div>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            borderSpacing: 0,
          }}
        >
          <thead>
            <tr
              style={{
                textAlign: "left",
                background: "#eee",
                borderRadius: "6px",
              }}
            >
              <th style={{ padding: "10px" }}>Name</th>
              <th style={{ padding: "10px" }}>Joined Date</th>
              <th style={{ padding: "10px" }}>Status</th>
              <th style={{ padding: "10px" }}>Action</th>
            </tr>
          </thead>
            <TableBody>
            {team.members.map((member,index) => (
                <TableRow key={index}>
                <TableCell>{member.user.displayName}</TableCell>
                <TableCell>2025-01-15</TableCell>
                <TableCell>{member.status}</TableCell>
                <TableCell>
                    {this.renderMemberAction(member)}
                </TableCell>
                </TableRow>
            ))}
            </TableBody>
        </table>
      </div>
    );
      }

      if(this.state.showInvite){
        return(
            <InviteTeamMembers inviteMember={this.inviteMember} userByEmail={this.userByEmail} />
        )
      }

      return (
<Box sx={{ p: 5 }}>
  {/* Header */}
  <Grid
    container
    justifyContent="space-between"
    alignItems="center"
    sx={{ mb: 4 }}
  >
    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
      Team &gt; {team.name}
    </Typography>

    <Box
      onClick={() => this.setState({ showMember: true })}
      sx={{ display: "flex", alignItems: "center", gap: 2, cursor: "pointer" }}
    >
    <AvatarGroup 
      max={4}
      style={{ display: 'flex', alignItems: 'center' }}
    >
      {team.members.slice(0, 3).map((member, index) => {
        const colors = ['#ef5350', '#42a5f5', '#ff9800']; // red, blue, orange
        let username = member.user.displayName
        return (
          <UserAvatar
            key={username}
            avatar={member.user.avatar}
            name={username}
            size={32}
            style={{
              backgroundColor: colors[index],
              fontWeight: 600,
              border: '2px solid #424242',
            }}
          />
        );
      })}
    </AvatarGroup>
    {team.members.length > 3 && (
      <span style={{ marginLeft: '4px', marginRight:'1em', fontSize:'16px', color: '#757575', fontWeight: 600 }}>
        +{team.members.length - 3}
      </span>
    )}

      <Button
        variant="outlined"
        onClick={(e) => {
          e.stopPropagation(); // prevent triggering showMember
          this.setState({ showInvite: true });
        }}
        style={{
          borderColor: "#F35D4A",
          color: "#F35D4A",
          textTransform: "none",
          fontWeight: "bold",
          px: 2.5,
          py: 0.8,
          borderRadius: "8px",
        }}
      >
        + INVITE
      </Button>
    </Box>
  </Grid>

  {/* Table header */}
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <Grid
        container
        style={{
          fontWeight: "bold",
          //marginBottom: '12px',
          marginTop:'12px',
          paddingBottom: '4px',
          borderBottom: "1px solid #ddd",
        }}
      >
        <Grid item xs={4}>
          Jam name
        </Grid>
        <Grid item xs={2}>
          Member
        </Grid>
        <Grid item xs={3}>
          Status
        </Grid>
        <Grid item xs={3}>
          Created by
        </Grid>
      </Grid>

      {/* Jam rows */}
      {team.jams.map((jam, i) => (
        <Grid
          container
          key={i}
          alignItems="center"
          style={{
            cursor:'pointer',
            paddingTop: '12px',
            paddingBottom: '12px',
            borderBottom: i !== mockJams.length - 1 ? "1px solid #f0f0f0" : "none",
          }}
          onClick={()=>{
            //console.log(jam._id)
            window.location.href=`/game/${jam._id}`
          }}
        >
          <Grid item xs={4}>
            {jam.name}
          </Grid>
          <Grid item xs={2}>
            {jam.participants.length}
          </Grid>
          <Grid item xs={3}>
            <Box
              style={{
                backgroundColor:
                  jam.status === "Jamming" ? "#d1f3d1" : "#e2e8f0",
                color: jam.status === "Jamming" ? "#256029" : "#475569",
                padding: '4px 12px 4px 12px',
                borderRadius: "8px",
                display: "inline-block",
                fontSize: "0.8rem",
              }}
            >
              {jam.status}
            </Box>
          </Grid>
          <Grid item xs={3}>
            {jam.createdBy.name.first}
          </Grid>
        </Grid>
      ))}
    </Grid>
  </Grid>

  {/* Templates by team member — interpreted templates created by any member of this team */}
  <Box sx={{ mt: 5 }}>
    <p style={{fontWeight:"bold", fontSize:"16px", color:"#4F4F4F", marginBottom:"10px"}}>Template by Team</p>
    {this.state.teamTemplatesLoading && !this.state.teamTemplates[team._id]
      ? this.renderLoader()
      : this.renderTeamTemplateTable(this.state.teamTemplates[team._id])}
  </Box>
</Box>

      );
    }

    // 🧩 2️⃣ Create a team form
    if (showCreateTeam) {
      return (
        <Grid
          container
          justifyContent="center"

          alignItems="center"
          style={{ height: "70vh", textAlign: "center" }}
        >
          <Grid item xs={6}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
              Create a Team
            </Typography>
            <img
              src={require("../../../element/2024aug/team_icon.png")}
              alt="team"
              style={{ width: "70px", opacity: 0.8, marginBottom: "1rem" }}
            />
            <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
              Jam with regular members and add series of jams into a team.
            </Typography>

            <TextField
              variant="outlined"
              placeholder="Team Edward"
              fullWidth
              value={this.state.newTeamName || ""}
              onChange={(e) => this.setState({ newTeamName: e.target.value })}
              InputProps={{
                style: {
                  backgroundColor: "#fff8ed",
                  textAlign: "center",
                  borderRadius: "10px",
                },
              }}
              sx={{ mb: 3 }}
            />

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#F35D4A",
                color: "white",
                padding: "10px 30px",
                borderRadius: "6px",
                textTransform: "uppercase",
                fontWeight: "bold",
              }}
              onClick={() => {
                const name = this.state.newTeamName?.trim();
                // console.log(name)
                if (name) {

                  this.props.client.mutate({
                      mutation: CREATE_TEAM,
                      variables: {
                        name: name,
                        members: [],
                        createdBy: getUserId(),
                      }
                  }).then((res)=>{
                    // console.log(res.data)
                    this.setState((prev) => ({
                      teams: [...prev.teams, res.data.teamCreateOne],
                      showCreateTeam: false,
                      selectedTeam: res.data.teamCreateOne._id,
                      selectedTeamData: res.data.teamCreateOne,
                      newTeamName: "",
                    }));
                    // Load the new team's "Templates by team member" list (creator's own).
                    this.loadTeamTemplates(res.data.teamCreateOne)
                    // Creating a team makes the user a team member -> tier 2. Refresh so
                    // the newly-unlocked features appear without a manual reload.
                    this.refreshTierAccess()
                  })

                }
              }}
            >
              ADD TEAM
            </Button>
          </Grid>
        </Grid>
      );
    }

    // 🧩 1️⃣ No team view
    return (
      <Grid container justifyContent="center" alignItems="center" style={{ height: "70vh" }}>
        <Grid item xs={6} style={{ textAlign: "center" }}>
          <img
            src={require("../../../element/2024aug/box_icon.png")}
            alt="no team"
            style={{ width: "90px", opacity: 0.8, marginBottom: "1rem" }}
          />
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            You have no team.
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
            Create a new team and add your friends to jam together.
          </Typography>
          <Button
            variant="contained"
            sx={{ backgroundColor: "#F35D4A", color: "white", textTransform: "none" }}
            onClick={() => this.setState({ showCreateTeam: true })}
          >
            Add a team
          </Button>
        </Grid>
      </Grid>
    );
  };




  //Open a jambuilder's preview dialog from a template-list row. Resolve whether it's the
  //user's own template (custom-personal) or a community one (custom-other) so the later
  //host/createTemplate flow can locate it. dialogDeck is reset so displayInfo refetches the deck.
  openTemplatePreview = (row) => {
    const isOwn = row.createdBy?._id === this.state.uid
    if(isOwn){
        //Own template (mirrors frontPageOld): interpreted templates open the Host/Customize
        //prompt; unfinished drafts go straight to the Jam Builder to continue building.
        this.jbID = row._id
        this.jbIndex = this.state.jambuilders.findIndex(p => p._id === row._id)
        if(row.status !== "interpreted"){
            //draft: record recent access, then open the editor to keep building
            this.props.client.mutate({
                mutation: USER_UPDATE_ACTIVITY,
                variables: { _id: this.state.uid, _aid: row._id, type: "template", date: new Date() }
            }).then(() => {
                window.location.href = `/jambuilder/${row._id}`
            }).catch(() => {
                window.location.href = `/jambuilder/${row._id}`
            })
            return
        }
        //interpreted: show the preview dialog (Host / Customize)
        this.setState({
            dialogDeck: null,
            dialogOpen: true,
            selectedJB: {
                jbData: row,
                type: "custom-personal"
            }
        })
        return
    }
    //a community template: open the preview dialog to host/customize a copy.
    this.jbIndex = this.state.publicJambuilders.findIndex(p => p._id === row._id)
    this.setState({
        dialogDeck: null,
        dialogOpen: true,
        selectedJB: {
            jbData: row,
            type: "custom-other"
        }
    })
  };

  //Open a Home featured template by id (lazy-fetched on click, so Home doesn't need the full
  //public-template list). flags carry the featured kind (turntaking/cover/brainstorm) that
  //createGame reads via selectedJB.
  openFeaturedTemplate = async (id, flags = {}) => {
    try{
        const res = await this.props.client.query({
            query: GET_JAMBUILDER_BY_ID(id),
            fetchPolicy: "no-cache"
        })
        const jbData = res.data.jamBuilderById
        if(!jbData){
            console.log("Unable to find featured template", id)
            return
        }
        this.setState({
            dialogDeck: null,
            dialogOpen: true,
            selectedJB: { jbData, type: "custom-other", ...flags }
        })
    }catch(err){
        console.error("featured template fetch failed:", err)
    }
  };

  //Small orange (brand color) loading spinner shown beneath a list while its data loads.
  renderLoader = () => {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "2rem" }}>
        <CircularProgress style={{ color: "#F35D4A" }} size={32} />
      </div>
    );
  };

  //Orange "Load more" control under a server-paginated list. Shows a spinner while the
  //next page is fetching, the button when more pages exist, or nothing when exhausted.
  renderLoadMore = (hasMore, onLoadMore, loadingMore) => {
    if(loadingMore){ return this.renderLoader() }
    if(!hasMore){ return null }
    return (
      <div style={{ textAlign: "center", padding: "0.75rem" }}>
        <Button onClick={onLoadMore} style={{ color: "#F35D4A", textTransform: "none", fontWeight: "bold" }}>
          Load more
        </Button>
      </div>
    );
  };

  //Shared table for template lists (My Templates, Community, Recent Templates), styled like
  //the recent-jams table. Columns: template name, deck, visibility.
  //hasMore/onLoadMore/loadingMore are optional — when onLoadMore is given, a server-driven
  //"Load more" control renders under the list.
  renderTemplateTable = (templates, hasMore, onLoadMore, loadingMore) => {
    if(!templates || templates.length === 0){
        return (<div>No Templates</div>)
    }
    return (
      <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: "bold" }}>Template Name</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Deck</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Visibility</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {templates.map((row, idx) => (
              <TableRow
                onClick={() => this.openTemplatePreview(row)}
                key={row._id || idx}
                style={{ borderBottom: "none", cursor: "pointer" }}
              >
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.deckTitle}</TableCell>
                <TableCell>{row.general?.privacy}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {onLoadMore && this.renderLoadMore(hasMore, onLoadMore, loadingMore)}
      </>
    );
  };

  //Flat table for "Templates by team member": one row per template created by any team
  //member, with a Created by column. Row click reuses openTemplatePreview (a teammate's
  //template opens as a host/customize-a-copy preview).
  renderTeamTemplateTable = (templates) => {
    if(!templates || templates.length === 0){
        return (<div>No Templates</div>)
    }
    return (
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: "bold" }}>Template Name</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Created by</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Deck</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Visibility</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {templates.map((row, idx) => (
              <TableRow
                onClick={() => this.openTemplatePreview(row)}
                key={row._id || idx}
                style={{ borderBottom: "none", cursor: "pointer" }}
              >
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.createdBy?.name?.first}</TableCell>
                <TableCell>{row.deckTitle}</TableCell>
                <TableCell>{row.general?.privacy}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  //hasMore/onLoadMore/loadingMore are optional — when onLoadMore is given, a server-driven
  //"Load more" control renders under the list.
  renderRecent = (ra, hasMore, onLoadMore, loadingMore) => {
    if(ra.length > 0){
        return (
        <>
        <TableContainer>
            <Table>
            <TableHead>
                <TableRow>
                <TableCell style={{ fontWeight: "bold" }}>Jam Name</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Member</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Created By</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Team</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {ra.map((row, idx) => (
                <TableRow onClick={()=>{this.props.history.push({pathname:`/game/${row._id}`})}} key={idx} style={{ borderBottom: "none", cursor:"pointer" }}>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.participants.length}</TableCell>
                    <TableCell>{row.createdBy.name.first}</TableCell>
                    <TableCell>{row.team ? row.team : ""}</TableCell>
                </TableRow>
                ))}
            </TableBody>
            </Table>
        </TableContainer>
        {onLoadMore && this.renderLoadMore(hasMore, onLoadMore, loadingMore)}
        </>
        );
    }else{
        return(<div>No Recent</div>)
    }

  };

  // Inline notice shown when a dashboard section is locked behind a capability the
  // user hasn't unlocked yet — tells them what to do next instead of a blank panel.
  renderTierLocked = (capability) => {
    return (
      <div style={{ maxWidth: 480, margin: "8vh auto", textAlign: "center", color: "#4F4F4F" }}>
        <h2 style={{ fontSize: 18, fontWeight: "bold" }}>Locked</h2>
        <p style={{ fontSize: 14, color: "#828282" }}>{hintFor(capability)}</p>
      </div>
    );
  };

  renderRightPanel = () => {
    const { selectedMenu } = this.state;
    switch (selectedMenu) {
      case "home":
        return this.renderHome();
      case "recent":
        return (
          <>
            <p style={{fontWeight:"bold", fontSize:"16px", color:"#4F4F4F", marginBottom:"10px"}}>Recent Jams</p>
            {this.state.activityLoading ? this.renderLoader() : this.renderRecent(this.state.recentActivity)}
            <div style={{marginTop:"2em"}}>
              <p style={{fontWeight:"bold", fontSize:"16px", color:"#4F4F4F", marginBottom:"10px"}}>Recent Templates</p>
              {this.state.activityLoading ? this.renderLoader() : this.renderTemplateTable(this.state.recentTemplatesList)}
            </div>
          </>
        );
      case "hosted":
        return this.state.hostedLoading
          ? this.renderLoader()
          : this.renderRecent(this.state.userJams, this.state.hostedHasMore, this.loadMoreHosted, this.state.hostedLoadingMore);
      case "joined":
        // "Joined" = recent games the user took part in but did NOT host. The host is
        // also stored as a participant (Game.js seeds participants with uid: createdBy),
        // so hosted vs joined is distinguished by createdBy, not participant membership.
        return this.state.activityLoading
          ? this.renderLoader()
          : this.renderRecent(this.state.recentActivity.filter(g => g.createdBy?._id !== getUserId()));
      case "team":
        // Team management is a tier-5 capability.
        if(!can("team_management", this.state.capabilities)){
          return this.renderTierLocked("team_management");
        }
        return this.state.teamsLoading ? this.renderLoader() : this.renderTeam();
      case "profile":
        return this.state.profileLoading ? this.renderLoader() : this.renderProfile();
      case "templates":
      default:
        return this.renderTemplates();
    }
  };

  // Profile tab content: avatar upload, nickname (name.first), and change password.
  renderProfile = () => {
    const {
      profileAvatar, avatarDraft,
      profileName, nameDraft,
      showPasswordForm, currentPassword, newPassword, confirmPassword, passwordMsg,
    } = this.state;

    const shownAvatar = avatarDraft || profileAvatar;
    const avatarDirty = Boolean(avatarDraft) && avatarDraft !== profileAvatar;
    const nameDirty = nameDraft !== profileName;

    const sectionTitle = { fontWeight: "bold", fontSize: "20px", color: "#4F4F4F", margin: "0 0 12px 0" };
    const grayBtn = { background: "#BDBDBD", color: "#fff", fontWeight: "bold", textTransform: "none" };
    const activeBtn = { background: "#FA841B", color: "#fff", fontWeight: "bold", textTransform: "none" };

    return (
      <div style={{ maxWidth: 460 }}>
        {/* AVATAR */}
        <p style={sectionTitle}>Avatar</p>
        <div style={{ display: "flex", justifyContent: "center", width: 360, marginBottom: 8 }}>
          {avatarUrl(shownAvatar, 200)
            ? <UserAvatar avatar={shownAvatar} name={profileName} size={200} style={{ border: "2px solid #2F80ED" }} />
            : <div style={{ width: 200, height: 200, borderRadius: "50%", border: "2px solid #2F80ED", background: "#D9D9D9", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <ImageOutlined style={{ fontSize: 64, color: "#B0B0B0" }} />
              </div>
          }
        </div>
        <p style={{ color: "#4F4F4F", fontSize: 13, margin: "6px 0 16px 0" }}>PNG, JPG or WebP up to 5 MB. You can position and zoom the photo after choosing it.</p>

        <Button component="label" variant="outlined" style={{ width: 360, textTransform: "none", fontWeight: "bold", color: "#4F4F4F", borderColor: "#c4c4c4", marginBottom: 12 }}>
          Upload Image
          <input type="file" accept="image/png,image/jpeg,image/webp" hidden onChange={this.handleAvatarPick} />
        </Button>
        <AvatarCropDialog open={!!this.state.cropImage} image={this.state.cropImage} onClose={this.closeCrop} onConfirm={this.handleAvatarCropped} />
        <div style={{ display: "flex", gap: 12 }}>
          <Button onClick={this.saveAvatar} disabled={!avatarDirty} style={avatarDirty ? activeBtn : grayBtn}>Save Changes</Button>
          <Button onClick={this.cancelAvatar} disabled={!avatarDirty} style={grayBtn}>Cancel</Button>
        </div>

        {/* NICKNAME */}
        <p style={{ ...sectionTitle, marginTop: 36 }}>Nickname</p>
        <div style={{ position: "relative", width: 360, marginBottom: 12 }}>
          <InputBase
            value={nameDraft}
            onChange={(e) => this.setState({ nameDraft: e.target.value })}
            style={{
              width: "100%", background: "#FAF7EA", border: "1px solid #E0D9B8",
              borderRadius: 6, padding: "10px 40px 10px 14px", fontSize: 16, color: "#4F4F4F",
            }}
          />
          <EditIcon style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", fontSize: 20, color: "#4F4F4F" }} />
        </div>
        <div style={{ display: "flex", gap: 12 }}>
          <Button onClick={this.saveName} disabled={!nameDirty} style={nameDirty ? activeBtn : grayBtn}>Save Changes</Button>
          <Button onClick={this.cancelName} disabled={!nameDirty} style={grayBtn}>Cancel</Button>
        </div>

        {/* SECURITY */}
        <p style={{ ...sectionTitle, marginTop: 36 }}>Security Setting</p>
        {passwordMsg &&
          <p style={{ margin: "0 0 10px 0", fontSize: 13, color: passwordMsg.type === "error" ? "#E45858" : "#27AE60" }}>
            {passwordMsg.text}
          </p>
        }
        {!showPasswordForm ? (
          <Button
            onClick={() => this.setState({ showPasswordForm: true, passwordMsg: null })}
            style={{ background: "#E15241", color: "#fff", fontWeight: "bold", textTransform: "none", width: "fit-content", padding: "8px 20px" }}
          >
            Reset Password
          </Button>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 10, width: 360 }}>
            <InputBase
              type="password"
              placeholder="Current password"
              value={currentPassword}
              onChange={(e) => this.setState({ currentPassword: e.target.value, passwordMsg: null })}
              style={{ background: "#F7F7F7", border: "1px solid #E0E0E0", borderRadius: 6, padding: "10px 14px", fontSize: 15 }}
            />
            <InputBase
              type="password"
              placeholder="New password"
              value={newPassword}
              onChange={(e) => this.setState({ newPassword: e.target.value, passwordMsg: null })}
              style={{ background: "#F7F7F7", border: "1px solid #E0E0E0", borderRadius: 6, padding: "10px 14px", fontSize: 15 }}
            />
            <InputBase
              type="password"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => this.setState({ confirmPassword: e.target.value, passwordMsg: null })}
              style={{ background: "#F7F7F7", border: "1px solid #E0E0E0", borderRadius: 6, padding: "10px 14px", fontSize: 15 }}
            />
            <div style={{ display: "flex", gap: 12 }}>
              <Button
                onClick={this.changePassword}
                style={{ background: "#E15241", color: "#fff", fontWeight: "bold", textTransform: "none", padding: "8px 20px" }}
              >
                Change Password
              </Button>
              <Button
                onClick={this.cancelPasswordChange}
                style={{ background: "#BDBDBD", color: "#fff", fontWeight: "bold", textTransform: "none", padding: "8px 20px" }}
              >
                Cancel
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  };

      //Dialog popup to display info
      displayInfo = () =>{
          const {classes} = this.props
          const {selectedJB} = this.state
          //Default dialog data starts with "Basic Game"
          let image = require('../../../element/default-image.png')
          let name = "Basic Game"
          let description = "The most basic template ready to be used and modified to your needs. This template consists of 5 set of card decks from Character, Place, Events and 1 blank card for players to customize their own story"
          let endpoint = "storyDesign"
  
          // if redirect set jbID to redirect jbID
          if(this.props.location?.state?.redirect){
              this.jbID = this.props.location.state.jbID
          }
  
          if(selectedJB.type === "custom-personal" || selectedJB.type === "custom-other"){
              selectedJB?.jbData?.image ?
                  image = `${config.backend.uri}/static/uploads/${selectedJB.jbData.image}` :
                  image = require('../../../element/default-image.png')
  
              name = selectedJB.jbData.name
              description = selectedJB?.jbData?.general?.description
              endpoint = selectedJB.jbData.deckEndpoint
          }
          else if(selectedJB.type === "story"){
              name = "Story Game"
              description = "Everything you need to have to build story game. This template consists of 5 set of card decks from Character, Place, Events and 1 blank card for players to customize their own story"
              image = require('../../../element/OUAT1.jpg')
          }
          else if(selectedJB.type === "freeStyle"){
              name = "Free Style"
              description = "A jam in its simplest form. This template consists of many sets of card decks from Topics to Characters while allowing everyone to jam together at the same time."
          }else if(selectedJB.type === "brainstorm"){
              name = "Brainstorm"
              description = "New Brainstorm Jam"
          }
  
          if(!this.state.dialogDeck){

              // storyDesign / brainstorm are shared deck files that always exist, so read
              // them directly. Any other (custom) deck is sourced from the JamBuilder record
              // instead of getCustomDeck: the record stores the deck dump, so this works for
              // templates copied from another user — the old per-user file read 500'd because
              // the deck file only exists under the ORIGINAL owner's dir, not the copying user's.
              // dialogDeck falls back to [] (truthy) so a missing/empty deck won't refetch-loop.
              if(endpoint === "storyDesign" || endpoint === "brainstorm"){
                  const ep = endpoint === "brainstorm" ? "brainstorm" : endpoint
                  axios.get(`${config.backend.uri}/api/game/getDeck`,{params: {endpoint: ep}}).then((res)=>{
                      this.setState({ dialogDeck: res.data.deck?.elements || [] })
                  }).catch(()=> this.setState({ dialogDeck: [] }))
              }else{
                  this.props.client.query({
                      query: GET_JAMBUILDER_BY_ID(selectedJB.jbData._id),
                      fetchPolicy: "no-cache",
                  }).then((res)=>{
                      const deck = res.data?.jamBuilderById?.deck
                      this.setState({ dialogDeck: deck?.elements || [] })
                  }).catch(()=> this.setState({ dialogDeck: [] }))
              }
          }
          else{
              return(
                  <div className={classes.preview}>
                      <Grid container>
                          <Grid item xs={8}>
                              {/* <img alt="media-preview" className={classes.previewImage} src={image}/>   */}
  
                              <div style={{backgroundImage: `url(${image})`, backgroundSize: 'cover'}} className={classes.previewImage}></div>
  
                              <p style={{fontSize:"14px",fontWeight:"bold", color:"#4F4F4F"}}>
                                  {name}
                              </p>
                              <p style={{paddingRight:"20px", color:"#4F4F4F", fontSize:"14px"}}>
                                  {description}
                              </p>
                          </Grid>
                          <Grid item xs ={4}>
                              <Button
                                  className={classes.previewBtn}
                                  onClick={()=>{
                                      if(!getUserId()){
                                          this.props.history.push({
                                              pathname: "/login",
                                              state:{
                                                  selectedJB: selectedJB,
                                                  type: "1",
                                                  jbIndex: this.jbIndex
                                              }
                                          })
                                      }
                                      else{
                                          this.setState({
                                              dialogOpen: false
                                          },()=>{
                                              this.handleOpen("1")
                                          })
                                      }
                                  }}
                                  size={"small"}
  
                              >
                                  Host This Template
                              </Button>
  
                              {/* Customize/copy template → Jam Builder (tier 5, create_template).
                                  Disabled with a hover tooltip for logged-in users below tier 5. */}
                              <p style={{textAlign:"center"}}>
                                  <Tooltip
                                      arrow
                                      title={(getUserId() && !can("create_template", this.state.capabilities)) ? hintFor("create_template") : ""}
                                  >
                                    <span>
                                      <Link
                                          style={{
                                              color: (getUserId() && !can("create_template", this.state.capabilities)) ? "#bbb" : "orange",
                                              fontSize:"14px",
                                              fontWeight:"bold",
                                              textDecoration:"underline",
                                              cursor: (getUserId() && !can("create_template", this.state.capabilities)) ? "not-allowed" : "pointer",
                                          }}
                                          size={"small"}
                                          onClick={()=>{
                                              // Disabled for logged-in users without tier 5 (Jam Builder).
                                              if(getUserId() && !can("create_template", this.state.capabilities)){ return }
                                              if(!getUserId()){
                                                  this.props.history.push({
                                                      pathname: "/login",
                                                      state:{
                                                          selectedJB: selectedJB,
                                                          type: "0",
                                                          jbIndex: this.jbIndex
                                                      }
                                                  })
                                              }
                                              else if(selectedJB.type === "custom-personal"){
                                                  //own template: edit the existing one in the Jam Builder
                                                  //(record recent access first), instead of creating a copy.
                                                  this.props.client.mutate({
                                                      mutation: USER_UPDATE_ACTIVITY,
                                                      variables: { _id: this.state.uid, _aid: this.jbID, type: "template", date: new Date() }
                                                  }).then(() => {
                                                      window.location.href = `/jambuilder/${this.jbID}`
                                                  }).catch(() => {
                                                      window.location.href = `/jambuilder/${this.jbID}`
                                                  })
                                              }
                                              else{
                                                  //close the preview dialog, then open the popUp as a
                                                  //Template (handleOpen sets both open:true and type:"0")
                                                  this.setState({dialogOpen: false}, () => this.handleOpen("0"))
                                              }
                                          }}
                                      >
                                          {selectedJB.type === "custom-personal" ? "Edit template" : "Make a copy"}
                                      </Link>
                                    </span>
                                  </Tooltip>
                              </p>
                              <p style={{fontWeight:"bold", marginTop:"20px", fontSize:"14px", color:"#4F4F4F"}}>
                                  Deck List ({this.state.dialogDeck?.length})
                              </p>
  
                              {this.state.dialogDeck.slice(0,3).map((card, index) =>{
                                  return(
                                      <div key={`${card}-${index}`} className={classes.previewCard}>
                                          <p style={{fontWeight:"bold", color:"#4F4F4F"}}>
                                             {card.content}
                                          </p>
                                          <Tooltip title="Category">
                                              <p style={{background:"#5C969A",}} className={classes.previewCardLabel}>
                                                  <Apps className={classes.previewCardIcon}/>
                                                  {card.category}
                                              </p>
                                          </Tooltip>
                                          {card.label.map((label, index) =>{
                                              return (
                                                  <Tooltip key={`${label}-${index}`} title="Label">
                                                      <p style={{background:"#967B7B"}} className={classes.previewCardLabel}>
                                                          <LocalOfferOutlined className={classes.previewCardIcon}/>
                                                          {label}
                                                      </p>
                                                  </Tooltip>
                                              )
                                          })}
                                      </div>
                                  )
                              })}
                          </Grid>
                      </Grid>
                  </div>
              )
          }
      }

        //Game/Jambuilder modal
        popUp = (classes) => {
            //Note: type === 1 is Jam, 0 is Template
            const {type} = this.state
            return (
                <Card className={classes.popUp}>
                    <div className={classes.popUpHeader}>
                        {type !== "0" ? "Host a new Jam" : "Create a new Template"}
                    </div>
                    <Divider/>
                    <div className={classes.popUpContent}>
                        <FormControl style={{width: "100%", fontSize:"0.875rem", color:"#4F4F4F"}}>
                            <b>{type !=="0" ? "Jam Name *" : "Template Name *"}</b>
                            <p style={{color:"#828282", fontSize:"0.7rem", marginBottom:"5px"}}>Give your jam a unique name!</p>
                            <InputBase
                                className={classes.field}
                                placeholder="Example: Wayne's World"
                                name="name"
                                value={this.state.name}
                                onChange={this.handleChange}
                                inputProps={{style: {fontSize: "0.875rem", fontFamily:"arial" }, maxLength:17}}
                            />
                            {type !== "0" && (
                            <>
                                <div style={{color:"#4F4F4F"}}>

                                    <div style={{fontSize:"0.875rem", display:"flex", alignItems:"center"}}>
                                        <b>Jam Password</b>
                                        
                                        <div style={{marginLeft:"10px", display:"flex", alignItems:"center"}}>
                                            <Switch
                                                color="primary"
                                                checked={this.state.passwordEnabled}
                                                onChange={(e) => this.setState({ passwordEnabled: e.target.checked, password: "" })}
                                            />
                                        </div>

                                        <i style={{marginLeft:"0.2em", color:"#B8B8B8"}}>(Optional)</i>
                                    </div>

                                    <p style={{color:"#828282", fontSize:"0.7rem", marginBottom:"5px"}}>
                                        Only those with your jam’s password may view your waiting room. 
                                        If none is set, anyone can view your waiting room!
                                    </p>
                                </div>

                                {/* 🔥 Password Input (Disabled If Toggle = Off) */}
                                <InputBase
                                    className={classes.field}
                                    type="password"
                                    placeholder="password"
                                    name="password"
                                    value={this.state.password}
                                    disabled={!this.state.passwordEnabled}
                                    onChange={this.handleChange}
                                    inputProps={{style: {fontSize: "0.875rem", fontFamily:"arial" }}}
                                />
                                {/* 🔥 Team Dropdown */}
                                <FormControl style={{width:"100%", marginTop:"15px"}}>
                                    <b style={{fontSize:"0.875rem", color:"#4F4F4F"}}>Select Team</b>

                                    <Select
                                        value={this.state.jamSelectedTeamName}
                                        onChange={(e) => {
                                            if(e.target.value){
                                              this.setState({ 
                                                jamSelectedTeam: e.target.value, 
                                                jamSelectedTeamName: e.target.value.name 
                                              })
                                            }else{
                                              this.setState({
                                                jamSelectedTeam: null, 
                                                jamSelectedTeamName: null 
                                              })
                                            }
                                          }

                                        } 
                                          
                                        input={<InputBase className={classes.field} />}
                                        displayEmpty
                                        renderValue={(value) => {
                                            if (value === null) {
                                                return <span style={{color:"#BDBDBD"}}>Without team</span>;
                                            }
                                            //const selectedTeam = this.state.teams.find(t => t._id === value);
                                            //return selectedTeam ? selectedTeam.name : "Without team";
                                            return this.state.jamSelectedTeamName
                                        }}
                                    >
                                        <MenuItem value={null}>
                                            <em>Without team</em>
                                        </MenuItem>
                                        {this.state.teams.map(t => (
                                            <MenuItem key={t._id} value={t}>
                                                {t.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </>
                            )}



                            {type !== "0" ?
                            <>
                                <Button
                                    onClick={this.handleCreateJam}
                                    disabled={(this.state.name === '' ? true : false) || this.state.loading}
                                    className={this.state.name === '' ? classes.popUpBtnDisabled : classes.popUpBtn}
                                >
                                   {this.state.selectedJB.cover ? "Start Game": "Go to waiting room"}
                                </Button>
                            </> :
                            <>
                                <Button
                                    onClick={()=>{
                                        if(this.state.name === ""){
                                            alert("Please Fill All Information!")
                                        }else{
                                            this.createTemplate()
                                        }
                                    }}
                                    disabled={this.state.name === "" ? true:false}
                                    className={this.state.name === "" ? classes.popUpBtnDisabled : classes.popUpBtn}
                                >
                                    Go to Template Builder
                                </Button>
                            </>
                            }
                        </FormControl >
                    </div>
                </Card>
            )
        }

    handleOpen(getType){
        this.setState({
            open: true,
            type: getType
        })
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    handleChange = (event) => {
        let item = event.target.name
        this.setState({
            [item]: event.target.value
        })
    }

        createTemplate = async () =>{
        const creator = getUserId();
        const username = getUsername();
        const {jambuilders, selectedJB, publicJambuilders, uid} = this.state

        let jamBuilderGraph = []
        let general = {}
        let jamBuilder = null

        if(selectedJB.type === "custom-personal"){
            jamBuilder = jambuilders.find((jb) => {
                if(jb._id === this.jbID){
                    return jb
                }else{
                    console.log(false)
                }
            })
            general = jamBuilder.general

            // jamBuilderGraph = jambuilders.find((jambuilder) => {
            //     if(jambuilder._id === this.jbID){
            //         return jambuilder.graph
            //     }
            //     else{
            //         return false
            //     }
            // })
            // general = jambuilders.find((jambuilder) => {
            //     if(jambuilder._id === this.jbID){
            //         return jambuilder.general
            //     }
            //     else{
            //         return false
            //     }
            // })
        }
        else if(selectedJB.type === "custom-other"){
            //jbData is always the selected template (community list row or lazy-fetched
            //featured template), so use it directly instead of a possibly-unset index.
            jamBuilder = selectedJB.jbData
            general = selectedJB.jbData.general
        }

        //graph is no longer fetched in the dashboard list queries (too heavy); fetch it
        //lazily by id only for the template the user actually creates from. This record also
        //carries the deck (copied onto every JamBuilder), which we prefer over the file below.
        let recordDeck = null
        //Card objects sitting on the source template's canvas-setup game, copied over so the
        //new template's canvas starts pre-populated instead of blank (see CREATE_GAME data below).
        let copiedObjects = []
        if(jamBuilder && jamBuilder._id){
            const gres = await this.props.client.query({
                query: GET_JAMBUILDER_BY_ID(jamBuilder._id),
                fetchPolicy: "no-cache"
            })
            jamBuilderGraph = gres.data.jamBuilderById.graph
            recordDeck = gres.data.jamBuilderById.deck

            //The source template's canvas game is general.gameLink; pull its data.objects.
            //Deep-clone since it's a shared query result. Failures fall back to an empty canvas.
            const srcGameLink = gres.data.jamBuilderById.general && gres.data.jamBuilderById.general.gameLink
            if(srcGameLink){
                try{
                    const srcGame = await this.props.client.query({
                        query: GET_GAME_BY_ID(srcGameLink),
                        fetchPolicy: "no-cache"
                    })
                    const srcObjects = srcGame && srcGame.data && srcGame.data.gameById && srcGame.data.gameById.data
                                        ? srcGame.data.gameById.data.objects : null
                    if(srcObjects){
                        copiedObjects = JSON.parse(JSON.stringify(srcObjects))
                    }
                }catch(copyErr){
                    console.log("createTemplate: canvas object copy failed, starting empty", copyErr)
                    copiedObjects = []
                }
            }
        }

        let deckEndpoint = this.state.selectedJB.type === "custom-personal" || this.state.selectedJB.type === "custom-other" ?
                                {
                                    endpoint: this.state.selectedJB.jbData.deckEndpoint ,
                                    userDir: `${this.state.selectedJB.jbData.createdBy._id}-${replaceWhiteSpace(this.state.selectedJB.jbData.createdBy.name.first)}`,
                                }
                            :
                                {
                                    endpoint: "storyDesign",
                                }

        let deckAPI = deckEndpoint.endpoint === "storyDesign" ? `/api/game/getDeck` : `/api/game/getCustomDeck`;

        // console.log(deckEndpoint)

        // Prefer the source template's stored deck (copied onto the record). The per-user deck
        // FILE only exists under the ORIGINAL creator's dir, so reading it keyed to the template
        // author's dir breaks at 2nd-level customizations (C customizing B → B's dir has no file
        // → null deck). Fall back to the file only for storyDesign or legacy records with no deck.
        const deckFetch = (recordDeck && recordDeck.title)
                            ? Promise.resolve({ data: { deck: recordDeck } })
                            : axios.get(`${config.backend.uri}${deckAPI}`,{params: deckEndpoint})

        deckFetch.then((res)=>{
            let deck = res.data.deck

            const name = "Untitled Jam"
            const creator = getUserId();
            const gameGeneral = 
                                {
                                    name: "Game Jam",
                                    deckEndpoint: "storyDesign",
                                    rulebook:"💬 Host writes criteria by attaching card to their posts \n\n ⏱ Timer can be set manually\n\n💡 Share your idea during your turn\n\n🏆 Host will choose the best idea",
                                    description:"",
                                    privacy:"Private",
                                    playerMode:"Quick",
                                    spectateMode: true,
                                }
            const data = {
                objects : copiedObjects,
                latestObject : null,
                playerTurn: 0,
                turn: 1,
                phase: [],
                latestID: "0",
                general: gameGeneral
            }
    
            return this.props.client.mutate({
                mutation: CREATE_GAME,
                variables:{
                    name: name,
                    createdBy: creator,
                    data: data,
                    // automation: "story",
                    automation: this.state.selectedJB.type === "custom-personal" || this.state.selectedJB.type === "custom-other" ?
                                "JB:" + jamBuilder.configIndex + "/yamlConfig" : this.state.selectedJB.type,
                    setup: false,
                    build: true,
                }
            }).then((status)=>{
                let jbGeneral = gameGeneral
                jbGeneral.gameLink = status.data.gameCreateOne._id
                let gameID = status.data.gameCreateOne._id

                return this.props.client.mutate({
                    mutation: CREATE_JAMBUILDER,
                    variables:{
                        name: this.state.name,
                        createdBy: creator,
                        configIndex: `${creator}-${replaceWhiteSpace(username)}-${jambuilders.length+1}`,
                        deckEndpoint:  this.state.selectedJB.type === "custom-personal" || this.state.selectedJB.type === "custom-other" ?
                                            this.state.selectedJB.jbData.deckEndpoint :
                                            "storyDesign",
                        templateType: this.state.selectedJB.type,
                        jamBuilderGraph: jamBuilderGraph,
                        general: jbGeneral,
                        deck: deck,
                    }
                }).then((status) =>{

                    // *** TEMPORARY FOR FREESTYLE & STORY
                    // Deep-clone the shared default game-data blob: gd/gd2 are module-level
                    // singletons, so mutating them (builderID/gameDeck below) would leak state
                    // into the next template creation.
                    let fgd = JSON.parse(JSON.stringify(this.state.selectedJB.type === "story" ? gd : gd2))

                    fgd.builderID = status.data.jamBuilderCreateOne._id

                    // Seed the reference game with the deck that was actually selected and stored
                    // on the JamBuilder record (transformed into the canvas shape, mirroring the
                    // server jambuilderSetup). Previously fgd carried gd/gd2's hardcoded DEFAULT
                    // storyDesign gameDeck, so a freshly-created template's canvas showed the wrong
                    // deck until the user pressed COMPILE (which regenerates gameData from the
                    // record). Clone `deck` first since processDeckData mutates card objects.
                    try{
                        if(deck && deck.categories && deck.elements){
                            fgd.gameDeck = {
                                name: deck.title,
                                deck: processDeckData(JSON.parse(JSON.stringify(deck)))
                            }
                        }
                    }catch(seedErr){
                        console.log("createTemplate: deck seed failed, falling back to default gameDeck", seedErr)
                    }
                    // console.log(gameID)
                    this.props.client.mutate({
                        mutation: GAME_GD_UPDATE_BY_ID,
                        variables: {
                          _id : gameID,
                          gameData: fgd
                        }
                    })

                    return this.props.client.mutate({
                        mutation: USER_UPDATE_ACTIVITY,
                        variables:{
                            _id: uid,
                            _aid: status.data.jamBuilderCreateOne._id,
                            type: "template",
                            date: new Date()
                        }
                    }).then(() =>{
                        this.setState({name: "", selectedJB: {type: null, jbData: null}});
                        //Full reload so the Jam Builder editor mounts cleanly (it's a heavy,
                        //route-guarded page). Matches the game flow's window.location redirect.
                        window.location.href = `/jambuilder/${status.data.jamBuilderCreateOne._id}`
                    })

                })
            })
        }).catch((err) =>{
            console.error("createTemplate failed:", err)
            alert("Something went wrong creating your template. Please try again.")
            this.setState({ loading: false })
        })

    }

        handleCreateJam = () => {
        if (this.state.loading) {
            return;
        }

        if (this.state.type === '' || this.state.name === ''){
            alert('Please Fill All Information!');

            return;
        }

        //console.log(this.state.type)

        if (this.state.type === '3'){
            this.createBranch()
        }else{
            this.createGame();
        }


        this.setState({ loading: true });
    };

        createBranch = () => {
            
            let {name, selectedBranch, branchSuggest} = this.state
    
            let setup = {
                createdBy: getUserId(),
                name,
                password: this.passwordChecker(),
                team: this.state.jamSelectedTeam ? this.state.jamSelectedTeam._id : null,
            }
    
            let automationChange = null
            if(branchSuggest){
                let link = this.linkSegment(selectedBranch.data.general.suggestedTemplate)
                let jb = this.state.publicJambuilders.find((pjb)=>{return pjb._id === link})
    
                automationChange = jb.general.gameLink
            }
    
            // console.log(automationChange)
            // console.log(this.state.)
    
            this.props.client.mutate({
                mutation: DUPLICATE_GAME,
                variables: {
                    _id: selectedBranch._id,
                    setup,
                    automationChange,
                }
            }).then((status)=>{
                // console.log(status)
                this.setState({name:"",password:"", type: ""});
                this.jbIndex = null
                window.location.href=`/game/${status.data.gameDuplicate._id}`
                //window.location.reload(); // temporary for jambuilder setup
            })
        }
    
        createGame = () =>{
            let jamBuilder = null

            // Prefer the selected row (jbData) — it's always set by openTemplatePreview and carries
            // configIndex/general (all list queries return them). The old index-based lookups
            // (jambuilders.find / publicJambuilders[jbIndex]) return undefined for a TEAM template
            // that isn't in those lists, which crashed on jamBuilder.configIndex when hosting.
            if(this.state.selectedJB.type === "custom-personal"){
                jamBuilder = this.state.selectedJB.jbData ?? this.state.jambuilders.find((jambuilder) => jambuilder._id === this.jbID)
            }
            else if(this.state.selectedJB.type === "custom-other"){
                jamBuilder = this.state.selectedJB.jbData ?? this.state.publicJambuilders[this.jbIndex]
            }

            //featured templates are lazy-fetched into selectedJB.jbData (openFeaturedTemplate)
            if(this.state.selectedJB.brainstorm || this.state.selectedJB.cover || this.state.selectedJB.turntaking || this.state.selectedJB.freeplay || this.state.selectedJB.tutorial || this.state.selectedJB.starter){
                jamBuilder = this.state.selectedJB.jbData
            }
            // console.log(jamBuilder)

            //Guard: without a resolved template we can't build the automation string; bail loudly
            //instead of throwing "Cannot read configIndex of undefined".
            if(!jamBuilder){
                console.error("createGame: could not resolve the selected template", this.state.selectedJB)
                alert("Something went wrong opening this template. Please try again.")
                return
            }

            const {name} = this.state
            const creator = getUserId();
    
            if(jamBuilder?.general && "gameLink" in jamBuilder.general){
                // duplicate jam
                // console.log("duplicate jam")
                let setup = {
                    createdBy: creator,
                    name,
                    password: this.passwordChecker(),
                    team: this.state.jamSelectedTeam ? this.state.jamSelectedTeam._id : null,
                    // Stamp the source template so the challenge subsystem can identify this
                    // hosted game (host + joiners). jamBuilder._id is the JamBuilder id.
                    builderID: jamBuilder._id,
                }
                // console.log(jamBuilder.general.gameLink)
                this.props.client.mutate({
                    mutation: DUPLICATE_GAME,
                    variables: {
                        _id: jamBuilder.general.gameLink,
                        setup,
                        automationChange: null,
                    }
                }).then((status)=>{
                    // console.log(status)
                    this.setState({name:"",password:"", type: ""});
                    this.jbIndex = null
                    window.location.href=`/game/${status.data.gameDuplicate._id}`
                    //window.location.reload(); // temporary for jambuilder setup
                })
            }else{
                
                const general = jamBuilder?.general ?
                                    jamBuilder.general :
                                    {
                                        name: "Game Jam",
                                        deckEndpoint: "storyDesign",
                                        rulebook:"💬 Host writes criteria by attaching card to their posts \n\n ⏱ Timer can be set manually\n\n💡 Share your idea during your turn\n\n🏆 Host will choose the best idea",
                                        description:"",
                                        privacy:"Private",
                                        playerMode:"Quick",
                                        spectateMode:true,
                                    }
                const data = {
                    objects : [],
                    latestObject : null,
                    playerTurn: 0,
                    turn: 1,
                    phase: [],
                    latestID: "0",
                    general: general
                }
    
                // console.log(this.state.selectedJB.cover)

                this.props.client.mutate({
                    mutation: CREATE_GAME,
                    variables:{
                        name: name,
                        createdBy: creator,
                        data: data,
                        automation: this.state.selectedJB.type === "custom-personal" || this.state.selectedJB.type === "custom-other" ?
                                        "JB:" + jamBuilder.configIndex + "/yamlConfig" :
                                        this.state.selectedJB.type,
                        password: this.passwordChecker(),
                        setup: false,
                        status: this.state.selectedJB.cover ? "started" : "ready",
                        team: this.state.jamSelectedTeam ? this.state.jamSelectedTeam._id : null,
                        // Stamp the source template for the challenge subsystem (host + joiners).
                        builderID: jamBuilder._id,
                    }
                }).then((status)=>{
                    this.setState({name:"",password:"", type: ""});
                    this.jbIndex = null
                    window.location.href=`/game/${status.data.gameCreateOne._id}`
                    //console.log(status)
                })
            }
        }

            passwordChecker = () => {
        if(this.state.password === ""){
            return null
        }else{
            return this.state.password
        }
    }

    // filterUserTeam = (allTeams, uid) => {
    //   return allTeams.find((team)=>{
    //     let isMember = team.members?.some(m=>{
    //       m.user._id === uid
    //     })
    //     return isMember
    //   })
    // }


  render() {
    const {classes} = this.props
    const { selectedMenu,uid, teams, selectedTeam } = this.state;
    // console.log(this.state.publicJambuilders)
    // kick off the data load exactly once, as soon as the user id is available.
    // one-shot guard (this.dataRequested) so it doesn't re-fire on every render.
    if(!this.dataRequested && getUserId()){
      this.dataRequested = true
      this.jamPageQuery(getUserId())
      //teams is a small query but is needed by the host-jam popup's team dropdown from any
      //tab, so load it eagerly (non-blocking) rather than only on the Team tab.
      this.loadTeams()
      //publish redirect lands here with openPreview and needs the templates list to show it
      if(this.props?.location?.state?.openPreview){
        this.loadTemplates()
      }
    }
    // console.log(this.state)

    let x = getUserId()
    return (
      <>
        <GameTopPanel dashboard />
        {this.renderVerifyModal()}
        {this.renderTermsModal()}
        {x ?
            <Grid container style={{ height: "80vh"}}>
          {/* Left Menu */}
          <Grid item xs={2} style={{ background: "#F8F8F8" }}>
            <List>
              <ListItem
                button
                selected={selectedMenu === "home"}
                onClick={() => this.handleMenuClick("home")}
                style={selectedMenu === "home" ? { color: "red" } : {}}
              >
                <ListItemIcon><Roof /></ListItemIcon>
                <ListItemText  primary="Home" />
              </ListItem>
              <ListItem
                button
                selected={selectedMenu === "recent"}
                onClick={() => this.handleMenuClick("recent")}
                style={selectedMenu === "recent" ? { color: "red" } : {}}
              >
                <ListItemIcon><Clock /></ListItemIcon>
                <ListItemText primary="Recent" />
              </ListItem>
              <ListItem
                button
                selected={selectedMenu === "hosted"}
                onClick={() => this.handleMenuClick("hosted")}
                style={selectedMenu === "hosted" ? { color: "red" } : {}}
              >
                <ListItemIcon><Hat /></ListItemIcon>
                <ListItemText primary="Hosted" />
              </ListItem>
              <ListItem
                button
                selected={selectedMenu === "joined"}
                onClick={() => this.handleMenuClick("joined")}
                style={selectedMenu === "joined" ? { color: "red" } : {}}
              >
                <ListItemIcon><WavingDuo /></ListItemIcon>
                <ListItemText primary="Joined" />
              </ListItem>
              {/* Templates tab: hosting community/personal templates is a tier-3 (Host)
                  capability. Below tier 3 the tab is locked — those users can only host the
                  Tutorial and Starter jams. Gated on create_game_basic (= host any jam). */}
              {/* Hidden entirely below tier 3 (Host) — those users can only host the Tutorial
                  and Starter jams, so community/personal templates aren't relevant to them. */}
              {can("create_game_basic", this.state.capabilities) &&
              <ListItem
                button
                selected={selectedMenu === "templates"}
                onClick={() => this.handleMenuClick("templates")}
                style={selectedMenu === "templates" ? { color: "red" } : {}}
              >
                <ListItemIcon><Stack /></ListItemIcon>
                <ListItemText primary="Templates" />
              </ListItem>
              }
              {/* Deck Builder is a tier-4 (Deck Creator) capability — hidden below tier 4. */}
              {can("access_deckbuilder", this.state.capabilities) &&
              <ListItem
                button
                onClick={() => this.props.history.push({ pathname: "/deckbuilder" })}
              >
                <ListItemIcon><ViewModule /></ListItemIcon>
                <ListItemText primary="Decks" />
              </ListItem>
              }
          {/* TEAM MENU WITH ADD BUTTON */}
          <ListItem
            button
            selected={selectedMenu === "team" && !selectedTeam}
            onClick={() => this.handleMenuClick("team")}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: (selectedMenu === "team" && !selectedTeam) ? "red" : "inherit",
            }}
          >
            <Box style={{ display: "flex", alignItems: "center" }}>
              <ListItemIcon>
                <Group />
              </ListItemIcon>
              <ListItemText primary="Teams" />
            </Box>

            {/* ➕ Add Team Button */}
            <IconButton
                  size="small"
              style={{
                backgroundColor: "#F35D4A",
                color: "white",
                width: 22,
                height: 22,
                marginRight: 8,
                pointerEvents: "auto", // make sure it's clickable
                zIndex: 10, // sit above the ListItem
              }}
              onClick={(e) => {
                e.stopPropagation(); // prevent triggering menu click
                //console.log("SS")
                this.setState({ 
                  showCreateTeam: true ,
                  selectedTeam: null,
              });
              }}
              sx={{
                backgroundColor: "#F35D4A",
                color: "white",
                "&:hover": { backgroundColor: "#d94f3d" },
                width: 22,
                height: 22,
                ml: 1,
              }}
            >
              <AddIcon fontSize="small" />
            </IconButton>
          </ListItem>

          {/* LIST OF TEAMS (animated expand/collapse when the Teams menu is opened) */}
          <Collapse in={selectedMenu === "team"} timeout="auto" unmountOnExit>
            {this.state.teams.length > 0 &&
              this.state.teams.map((team, i) => (
                <ListItem
                  button
                  key={i}
                  selected={this.state.selectedTeam === team._id}
                  onClick={() =>
                    this.setState({
                      selectedTeam: team._id,
                      selectedTeamData: team,
                      showInvite: false,
                      showMember: false,
                      showCreateTeam: false,
                    })
                  }
                  style={{
                    paddingLeft: 72,
                    color: this.state.selectedTeam === team._id ? "red" : "inherit",
                  }}
                >
                  <ListItemText
                    primary={team.name}
                    primaryTypographyProps={{
                      fontWeight: this.state.selectedTeam === team._id ? "bold" : "medium",
                    }}
                  />
                </ListItem>
              ))
            }

            {/* If no team yet */}
            {this.state.teams.length === 0 && (
              <Typography
                variant="body2"
                style={{ marginLeft: 56, marginTop: 4, color: "#94a3b8", fontStyle: "italic" }}
              >
                No teams yet
              </Typography>
            )}
          </Collapse>

          {/* PROFILE */}
          <ListItem
            button
            selected={selectedMenu === "profile"}
            onClick={() => this.handleMenuClick("profile")}
            style={selectedMenu === "profile" ? { color: "red" } : {}}
          >
            <ListItemIcon><AccountCircle /></ListItemIcon>
            <ListItemText primary="Profile" />
          </ListItem>

            </List>
          </Grid>

          {/* Right Panel */}
          <Grid item xs={10} style={{ padding: "2rem", overflow:"scroll", maxHeight:"80vh" }}>
            {/* Top Row: menu name + action buttons */}
            <Grid container justifyContent="space-between" alignItems="center" style={{ marginBottom: "1rem" }}>
              <Grid item>
                <Typography variant="h6" style={{ fontWeight: "bold", textTransform: "capitalize" }}>
                  {selectedMenu}
                </Typography>
              </Grid>
             {this.state.selectedMenu !== "team" && this.state.selectedMenu !== "profile" &&

             <Grid item>
                {/* Free Play / Turn-Taking are tier-3 (host any jam). Disabled with a hover
                    tooltip below tier 3 — the span lets the tooltip work on a disabled button. */}
                <Tooltip arrow title={!can("create_game_basic", this.state.capabilities) ? hintFor("create_game_basic") : ""}>
                  <span style={{ marginRight: "0.5rem" }}>
                    <Button
                     disabled={!can("create_game_basic", this.state.capabilities)}
                     onClick={()=>{
                        this.openFeaturedTemplate(this.featuredIds.freeplay, {freeplay: true})
                     }}
                     variant="outlined" color="primary">
                      + FREE PLAY
                    </Button>
                  </span>
                </Tooltip>
                <Tooltip arrow title={!can("create_game_basic", this.state.capabilities) ? hintFor("create_game_basic") : ""}>
                  <span>
                    <Button
                      disabled={!can("create_game_basic", this.state.capabilities)}
                      onClick={()=>{
                          this.openFeaturedTemplate(this.featuredIds.turntaking, {turntaking: true});
                      }}
                     variant="outlined" color="secondary">
                      + TURN-TAKING
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
             
             }

            </Grid>

            {this.renderRightPanel()}
            <Dialog
                onClose={() =>
                    this.setState({
                        dialogOpen: false,
                        dialogDeck: null,
                    })}
                open={this.state.dialogOpen}
            >
                {this.state.dialogOpen && this.displayInfo()}
            </Dialog>
            {/* POP UP */}
            <Modal disableAutoFocus={true} className={classes.modal} open={this.state.open} onClose={this.handleClose}>
                {this.popUp(classes)}
            </Modal>
          </Grid>
            </Grid>
        :
            <Grid container spacing={4}  className={classes.container} style={{height:"80vh",width:"100%", maxWidth:"100%"}}>
                <Grid item md={7} xs={12}
                    style={{ 
                    backgroundColor: "#A8B0B3", // gray background
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center"
                    }}
                >
                    <img 
                    src={require("../../../element/2024aug/landing.png")} 
                    alt="illustration" 
                    style={{ maxWidth: "80%", height: "auto" }} 
                    />
                </Grid>
                <Grid item md={5} xs={12}
                    style={{ 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    backgroundColor: "#A8B0B3" 
                    }}
                >
                      <Landing/>     
                </Grid>        
                              
            </Grid>          
        }

        <FooterPanel />
      </>
    );
  }
      // FAST PATH (Home): fetch the user's tier + computed capabilities and paint Home
      // immediately. Home needs `access` (progress display) and `capabilities` (card
      // gating). The tier itself is kept current by server-side triggers and the
      // app-wide UserAccessProvider's evaluate-on-load, so there is nothing to set here.
      jamPageQuery = (uid) =>{
          this.props.client.query({
              query: USER_ACCESS_QUERY(uid),
              fetchPolicy: "no-cache"
          }).then((res) =>{
              const user = res.data.userById
              this.setState({
                  uid,
                  access: user.access,
                  capabilities: user.capabilities || [],
                  satisfiedCriteria: user.satisfiedCriteria || [],
                  challengeProgress: user.challengeProgress || null,
                  termsCurrent: user.termsCurrent === true,
              }) //Home can render now
          }).catch((err) =>{
              console.error("home access query failed:", err)
          })
      }

      // The community list is curated on the temp (IP-based) deployment: there it shows
      // only admin-flagged "Featured Community Templates" (featuredCommunity), while the
      // main site shows all public community templates. Pick the matching query + response
      // field once so loadTemplates / loadMoreCommunity stay in sync.
      communityQuery = () => appConfig.isTempSite ? JAMBUILDER_FEATURED_COMMUNITY_PAGE : JAMBUILDER_COMMUNITY_PAGE
      readCommunityPage = (res) => (res.data.jamBuilderFeaturedCommunityPage || res.data.jamBuilderCommunityPage) || []

      // LAZY: first page of My Templates + Community templates (Templates tab). Both are
      // server-paginated (newest first); "Load more" appends the next page.
      loadTemplates = () =>{
          const uid = getUserId()
          this.setState({ templatesLoading: true })
          Promise.all([
              this.props.client.query({ query: JAMBUILDER_PERSONAL_PAGE, variables: { uid, skip: 0, limit: this.PAGE_SIZE }, fetchPolicy: "no-cache" }),
              this.props.client.query({ query: this.communityQuery(), variables: { skip: 0, limit: this.PAGE_SIZE }, fetchPolicy: "no-cache" })
          ]).then(([myRes, commRes]) =>{
              const my = myRes.data.jamBuilderPersonalPage || []
              const comm = this.readCommunityPage(commRes)
              this.setState({
                  jambuilders: my,
                  myTemplatesSkip: my.length,
                  myTemplatesHasMore: my.length === this.PAGE_SIZE,
                  // Community list is filtered server-side (main: public+interpreted; temp:
                  // featuredCommunity+public+interpreted), so use the returned page as-is.
                  publicJambuilders: comm,
                  communitySkip: comm.length,
                  communityHasMore: comm.length === this.PAGE_SIZE,
                  templatesLoaded: true,
                  templatesLoading: false,
              }, () =>{
                  //after publishing a template we redirect here with openPreview to show it
                  if(this.props?.location?.state?.openPreview){
                      const { jbID } = this.props.location.state
                      let jbData = null
                      for(let i=0; i<this.state.jambuilders.length; i++){
                          if(this.state.jambuilders[i]._id === jbID){
                              jbData = this.state.jambuilders[i]
                              this.jbIndex = i
                              break
                          }
                      }
                      this.jbID = jbID
                      this.setState({ dialogOpen: true, selectedJB: { jbData, type: "custom-personal" } })
                      //consume the one-shot preview signal so it can't retrigger: history state
                      //is sticky (and persisted to sessionStorage), so without this the popup
                      //reopens on every dashboard remount/reload of this history entry.
                      this.props.history.replace({ ...this.props.location, state: {} })
                  }
              })
          }).catch((err) =>{
              console.error("templates load failed:", err)
              this.setState({ templatesLoading: false })
          })
      }

      loadMoreMyTemplates = () =>{
          const uid = getUserId()
          this.setState({ myTemplatesLoadingMore: true })
          this.props.client.query({ query: JAMBUILDER_PERSONAL_PAGE, variables: { uid, skip: this.state.myTemplatesSkip, limit: this.PAGE_SIZE }, fetchPolicy: "no-cache" })
              .then((res) =>{
                  const page = res.data.jamBuilderPersonalPage || []
                  this.setState(s => ({
                      jambuilders: [...s.jambuilders, ...page],
                      myTemplatesSkip: s.myTemplatesSkip + page.length,
                      myTemplatesHasMore: page.length === this.PAGE_SIZE,
                      myTemplatesLoadingMore: false,
                  }))
              }).catch((err) =>{
                  console.error("load more My Templates failed:", err)
                  this.setState({ myTemplatesLoadingMore: false })
              })
      }

      loadMoreCommunity = () =>{
          this.setState({ communityLoadingMore: true })
          this.props.client.query({ query: this.communityQuery(), variables: { skip: this.state.communitySkip, limit: this.PAGE_SIZE }, fetchPolicy: "no-cache" })
              .then((res) =>{
                  const page = this.readCommunityPage(res)
                  this.setState(s => ({
                      publicJambuilders: [...s.publicJambuilders, ...page],
                      communitySkip: s.communitySkip + page.length,
                      communityHasMore: page.length === this.PAGE_SIZE,
                      communityLoadingMore: false,
                  }))
              }).catch((err) =>{
                  console.error("load more Community failed:", err)
                  this.setState({ communityLoadingMore: false })
              })
      }

      // Teams for the Team tab — not paginated (bounded by the user's memberships).
      loadTeams = () =>{
          const uid = getUserId()
          this.setState({ teamsLoading: true })
          this.props.client.query({ query: DASHBOARD_TEAMS_QUERY, fetchPolicy: "no-cache" })
              .then((res) =>{
                  const teamMany = res.data.teamMany || []
                  const userTeam = teamMany.filter(team => team.members?.some(member => member.user._id === uid))
                  this.setState({ teams: userTeam, teamsLoaded: true, teamsLoading: false })
              }).catch((err) =>{
                  console.error("teams load failed:", err)
                  this.setState({ teamsLoading: false })
              })
      }

      // Templates created by a team's members ("Templates by team member"), fetched when a
      // team detail view is opened. One batch query for all members (interpreted only).
      // Cached per team id so re-opening a team doesn't refetch.
      loadTeamTemplates = (team) =>{
          if(!team || !team.members){ return }
          if(this.state.teamTemplates[team._id]){ return } // already loaded
          const ids = team.members.map(m => m.user._id)
          this.setState({ teamTemplatesLoading: true })
          this.props.client.query({ query: JAMBUILDER_BY_CREATORS, variables: { list: ids }, fetchPolicy: "no-cache" })
              .then((res) =>{
                  // Server already restricts this to public + interpreted templates by team members.
                  const templates = res.data.jamBuilderByCreators || []
                  this.setState(s => ({
                      teamTemplates: { ...s.teamTemplates, [team._id]: templates },
                      teamTemplatesLoading: false,
                  }))
              }).catch((err) =>{
                  console.error("team templates load failed:", err)
                  this.setState({ teamTemplatesLoading: false })
              })
      }

      // Hosted games (Hosted tab), server-paginated newest first. The server already
      // excludes the placeholder "Untitled Jam" games.
      loadHosted = () =>{
          const uid = getUserId()
          this.setState({ hostedLoading: true })
          this.props.client.query({ query: GAME_PERSONAL_PAGE, variables: { uid, skip: 0, limit: this.PAGE_SIZE }, fetchPolicy: "no-cache" })
              .then((res) =>{
                  const page = res.data.gamePersonalPage || []
                  this.setState({
                      userJams: page,
                      hostedSkip: page.length,
                      hostedHasMore: page.length === this.PAGE_SIZE,
                      hostedLoaded: true,
                      hostedLoading: false,
                  })
              }).catch((err) =>{
                  console.error("hosted load failed:", err)
                  this.setState({ hostedLoading: false })
              })
      }

      loadMoreHosted = () =>{
          const uid = getUserId()
          this.setState({ hostedLoadingMore: true })
          this.props.client.query({ query: GAME_PERSONAL_PAGE, variables: { uid, skip: this.state.hostedSkip, limit: this.PAGE_SIZE }, fetchPolicy: "no-cache" })
              .then((res) =>{
                  const page = res.data.gamePersonalPage || []
                  this.setState(s => ({
                      userJams: [...s.userJams, ...page],
                      hostedSkip: s.hostedSkip + page.length,
                      hostedHasMore: page.length === this.PAGE_SIZE,
                      hostedLoadingMore: false,
                  }))
              }).catch((err) =>{
                  console.error("load more hosted failed:", err)
                  this.setState({ hostedLoadingMore: false })
              })
      }

      // LAZY: recent activity (recent jams + recent templates) for Recent/Joined tabs.
      // Not paginated (bounded by the small recent-activity list). Hosted games load
      // separately in loadHosted.
      loadActivity = () =>{
          const uid = getUserId()
          this.setState({ activityLoading: true })
          this.props.client.query({
              query: GET_USER_ACTIVITY(uid),
              fetchPolicy: "no-cache"
          }).then((activityRes) =>{
              const recentActivity = activityRes.data.userById.recentActivity
              const recentTemplates = recentActivity.recentTemplates.map(t => t._id)
              const recentJams = recentActivity.recentJams.map(g => g._id)

              return this.props.client.query({
                  query: gql`${GET_JAMS_TEMPLATES}`,
                  variables: { tempList: recentTemplates, jamList: recentJams },
                  fetchPolicy: "no-cache"
              }).then((res) =>{
                  const jamBuilders = res.data.jamBuilderFilter.map(obj => Object.assign(obj, recentActivity.recentTemplates.find(t => obj._id === t._id)))
                  const games = res.data.gameFilter.map(obj => Object.assign(obj, recentActivity.recentJams.find(t => obj._id === t._id)))

                  const activityList = jamBuilders.concat(games)
                  const sortedActivity = activityList.sort((a, b) => (new Date(a.date).getTime()) < (new Date(b.date).getTime()) ? 1 : (((new Date(b.date).getTime()) < (new Date(a.date).getTime())) ? -1 : 0))

                  this.setState({
                      activityList: sortedActivity,
                      recentActivity: games,
                      recentTemplatesList: jamBuilders,
                      activityLoaded: true,
                      activityLoading: false,
                  })
              })
          }).catch((err) =>{
              console.error("activity load failed:", err)
              this.setState({ activityLoading: false })
          })
      }
}

export default withApollo(withRouter(withStyles(styles)(Dashboard)));
